window.vehicleDb = {
  "Audi": {
    "A3 • S3 • RS 3": {
      "8Y.2 (2025+)": [
        { "title": "A3 2.0T I4 EA888.4 quattro", "url": "/collections/audi-a3-8y-2-2-0t-i4-ea888-4-quattro" },
        { "title": "S3 2.0T I4 EA888.4 quattro", "url": "/collections/audi-s3-8y-2-2-0t-i4-ea888-4-quattro" },
        { "title": "RS 3 2.5T EA855e quattro", "url": "/collections/audi-rs-3-8y-2-2-5t-i5-ea855e-quattro" }
      ],
      "8Y (2022-2024)": [
        { "title": "A3 2.0T I4 EA888.4 FWD", "url": "/collections/audi-a3-8y-2-0t-i4-ea888-4-fwd" },
        { "title": "A3 2.0T I4 EA888.4 quattro", "url": "/collections/audi-a3-8y-2-0t-i4-ea888-4-quattro" },
        { "title": "S3 2.0T I4 EA888.4 quattro", "url": "/collections/audi-s3-8y-2-0t-i4-ea888-4-quattro" },
        { "title": "RS 3 2.5T I5 EA855e quattro", "url": "/collections/audi-rs-3-8y-2-5t-i5-ea855e-quattro" }
      ],
      "8V.2 (2017-2021)": [
        { "title": "A3 2.0T I4 EA888.3B FWD", "url": "/collections/audi-a3-8v-2-2-0t-i4-ea888-3b-fwd" },
        { "title": "A3 2.0T I4 EA888.3 quattro", "url": "/collections/audi-a3-8v-2-2-0t-i4-ea888-3-quattro" },
        { "title": "S3 2.0T I4 EA888.3 quattro", "url": "/collections/audi-s3-8v-2-2-0t-i4-ea888-3-quattro" },
        { "title": "RS 3 2.5T I5 EA855e quattro", "url": "/collections/audi-rs-3-8v-2-2-5t-i5-ea855e-quattro" }
      ],
      "8V (2014-2016)": [
        { "title": "A3 1.8T I4 EA888.3 FWD", "url": "/collections/audi-a3-8v-1-8t-i4-ea888-3-fwd" },
        { "title": "A3 2.0T I4 EA888.3 FWD", "url": "/collections/audi-a3-8v-2-0t-i4-ea888-3-fwd" },
        { "title": "A3 2.0T I4 EA888.3 quattro", "url": "/collections/audi-a3-8v-2-0t-i4-ea888-3-quattro" },
        { "title": "A3 2.0T TDI I4 EA189 FWD", "url": "/collections/audi-a3-8v-2-0t-tdi-i4-ea189-fwd" },
        { "title": "S3 2.0T I4 EA888.3 quattro", "url": "/collections/audi-s3-8v-2-0t-i4-ea888-3-quattro" }
      ],
      "8P (2005-2013)": [
        { "title": "A3 2.0T I4 EA113 FWD", "url": "/collections/audi-a3-8p-2-0t-i4-ea113-fwd" },
        { "title": "A3 2.0T I4 EA113 quattro", "url": "/collections/audi-a3-8p-2-0t-i4-ea113-quattro" },
        { "title": "A3 2.0T I4 EA888.1 FWD", "url": "/collections/audi-a3-8p-2-0t-i4-ea888-1-fwd" },
        { "title": "A3 2.0T I4 EA888.1 quattro", "url": "/collections/audi-a3-8p-2-0t-i4-ea888-1-quattro" },
        { "title": "A3 2.0T TDI I4 EA189 FWD", "url": "/collections/audi-a3-8p-2-0t-tdi-i4-ea189-fwd" },
        { "title": "A3 3.2L VR6 EA390 quattro", "url": "/collections/audi-a3-8p-3-2l-vr6-ea390-quattro" }
      ]
    },
    "A4 • S4 • RS 4": {
      "B9.2 (2021-2024)": [
        { "title": "A4 2.0T I4 EA888.4B quattro", "url": "/collections/audi-a4-b9-2-2-0t-i4-ea888-4b-quattro" },
        { "title": "A4 2.0T I4 EA888.4 quattro", "url": "/collections/audi-a4-b9-2-2-0t-i4-ea888-4-quattro" },
        { "title": "A4 allroad 2.0T I4 EA888.4 quattro", "url": "/collections/audi-a4-allroad-b9-2-2-0t-i4-ea888-4-quattro" },
        { "title": "S4 3.0T V6 EA839 quattro", "url": "/collections/audi-s4-b9-2-3-0t-v6-ea839-quattro" }
      ],
      "B9 (2017-2020)": [
        { "title": "A4 2.0T I4 EA888.3B FWD", "url": "/collections/audi-a4-b9-2-0t-i4-ea888-3b-fwd" },
        { "title": "A4 2.0T I4 EA888.3B quattro", "url": "/collections/audi-a4-b9-2-0t-i4-ea888-3b-quattro" },
        { "title": "A4 2.0T I4 EA888.3 quattro", "url": "/collections/audi-a4-b9-2-0t-i4-ea888-3-quattro" },
        { "title": "A4 allroad 2.0T I4 EA888.3 quattro", "url": "/collections/audi-a4-allroad-b9-2-0t-i4-ea888-3-quattro" },
        { "title": "S4 3.0T V6 EA839 quattro", "url": "/collections/audi-s4-b9-3-0t-v6-ea839-quattro" }
      ],
      "B8.2 (2013-2016)": [
        { "title": "A4 2.0T I4 EA888.2 FWD", "url": "/collections/audi-a4-b8-2-2-0t-i4-ea888-2-fwd" },
        { "title": "A4 2.0T I4 EA888.2 quattro", "url": "/collections/audi-a4-b8-2-2-0t-i4-ea888-2-quattro" },
        { "title": "A4 2.0T I4 EA888.3 quattro", "url": "/collections/audi-a4-b8-2-2-0t-i4-ea888-3-quattro" },
        { "title": "A4 allroad 2.0T I4 EA888.2 quattro", "url": "/collections/audi-a4-allroad-b8-2-2-0t-i4-ea888-2-quattro" },
        { "title": "S4 3.0S V6 EA837 quattro", "url": "/collections/audi-s4-b8-2-3-0s-v6-ea837-quattro" }
      ],
      "B8 (2009-2012)": [
        { "title": "A4 2.0T I4 EA888.2 FWD", "url": "/collections/audi-a4-b8-2-0t-i4-ea888-2-fwd" },
        { "title": "A4 2.0T I4 EA888.2 quattro", "url": "/collections/audi-a4-b8-2-0t-i4-ea888-2-quattro" },
        { "title": "A4 3.2L V6 EA837 quattro", "url": "/collections/audi-a4-b8-3-2l-v6-ea837-quattro" },
        { "title": "S4 3.0S V6 EA837 quattro", "url": "/collections/audi-s4-b8-3-0t-v6-ea837-quattro" }
      ],
      "B7 (2005-2008)": [
        { "title": "A4 2.0T I4 EA113 FWD", "url": "/collections/audi-a4-b7-2-0t-i4-ea113-fwd" },
        { "title": "A4 2.0T I4 EA113 quattro", "url": "/collections/audi-a4-b7-2-0t-i4-ea113-quattro" },
        { "title": "A4 3.2L V6 EA837 quattro", "url": "/collections/audi-a4-b7-3-2l-v6-ea837-quattro" },
        { "title": "S4 4.2L V8 EA824 quattro", "url": "/collections/audi-s4-b7-4-2l-v8-ea824-quattro" },
        { "title": "RS 4 4.2L V8 EA824 quattro", "url": "/collections/audi-rs-4-b7-4-2l-v8-ea824-quattro" }
      ],
      "B6 (2002-2004)": [
        { "title": "A4 1.8T I4 EA113 FWD", "url": "/collections/audi-a4-b6-1-8t-i4-ea113-fwd" },
        { "title": "A4 1.8T I4 EA113 quattro", "url": "/collections/audi-a4-b6-1-8t-i4-ea113-quattro" },
        { "title": "A4 1.9T TDI I4 EA188 FWD", "url": "/collections/audi-a4-b6-1-9t-tdi-i4-ea188-fwd" },
        { "title": "A4 1.9T TDI I4 EA188 quattro", "url": "/collections/audi-a4-b6-1-9t-tdi-i4-ea188-quattro" },
        { "title": "A4 3.0L V6 EA835 FWD", "url": "/collections/audi-a4-b6-3-0l-v6-ea835-fwd" },
        { "title": "A4 3.0L V6 EA835 quattro", "url": "/collections/audi-a4-b6-3-0l-v6-ea835-quattro" },
        { "title": "S4 4.2L V8 EA824 quattro", "url": "/collections/audi-s4-b6-4-2l-v8-ea824-quattro" }
      ],
      "B5 (1996-2001)": [
        { "title": "A4 1.8T I4 EA113 FWD", "url": "/collections/audi-a4-b5-1-8t-i4-ea113-fwd" },
        { "title": "A4 1.8T I4 EA113 quattro", "url": "/collections/audi-a4-b5-1-8t-i4-ea113-quattro" },
        { "title": "A4 2.8L V6 EA835 FWD", "url": "/collections/audi-a4-b5-2-8l-v6-ea835-fwd" },
        { "title": "A4 2.8L V6 EA835 quattro", "url": "/collections/audi-a4-b5-2-8l-v6-ea835-quattro" },
        { "title": "S4 2.7T V6 EA835 quattro", "url": "/collections/audi-s4-b5-2-7t-v6-ea835-quattro" }
      ]
    },
    "A5 • S5 • RS 5": {
      "B10 (2025+)": [
        { "title": "A5 2.0T I4 EA888.5 quattro", "url": "/collections/audi-a5-b10-2-0t-i4-ea888-5-quattro" },
        { "title": "S5 3.0T V6 EA839e quattro", "url": "/collections/audi-s5-b10-3-0t-v6-ea839e-quattro" }
      ],
      "B9.2 (2021-2024)": [
        { "title": "A5 2.0T I4 EA888.4B quattro", "url": "/collections/audi-a5-b9-2-2-0t-ea888-4b-quattro" },
        { "title": "A5 2.0T I4 EA888.4 quattro", "url": "/collections/audi-a5-b9-2-2-0t-i4-ea888-4-quattro" },
        { "title": "S5 3.0T V6 EA839 quattro", "url": "/collections/audi-s5-b9-2-3-0t-v6-ea839-quattro" },
        { "title": "RS 5 2.9TT V6 EA839 quattro", "url": "/collections/audi-rs-5-b9-2-2-9tt-v6-ea839-quattro" }
      ],
      "B9 (2018-2020)": [
        { "title": "A5 2.0T I4 EA888.3 quattro", "url": "/collections/audi-a5-b9-2-0t-i4-ea888-3-quattro" },
        { "title": "S5 3.0T V6 EA839 quattro", "url": "/collections/audi-s5-b9-3-0t-v6-ea839-quattro" },
        { "title": "RS 5 2.9TT V6 EA839 quattro", "url": "/collections/audi-rs-5-b9-2-9tt-v6-ea839-quattro" }
      ],
      "B8.2 (2013-2017)": [
        { "title": "A5 2.0T I4 EA888.2 quattro", "url": "/collections/audi-a5-b8-2-2-0t-i4-ea888-2-quattro" },
        { "title": "A5 2.0T I4 EA888.3 quattro", "url": "/collections/audi-a5-b8-2-2-0t-i4-ea888-3-quattro" },
        { "title": "S5 3.0S V6 EA837 quattro", "url": "/collections/audi-s5-b8-2-3-0s-v6-ea837-quattro" },
        { "title": "RS 5 4.2L V8 EA824 quattro", "url": "/collections/audi-rs-5-b8-2-4-2l-v8-ea824-quattro" }
      ],
      "B8 (2008-2012)": [
        { "title": "A5 2.0T I4 EA888.2 quattro", "url": "/collections/audi-a5-b8-2-0t-i4-ea888-2-quattro" },
        { "title": "A5 3.2L V6 EA837 quattro", "url": "/collections/audi-a5-b8-3-2l-v6-ea837-quattro" },
        { "title": "S5 3.0S V6 EA837 quattro", "url": "/collections/audi-s5-b8-3-0s-v6-ea837-quattro" },
        { "title": "S5 4.2L V8 EA824 quattro", "url": "/collections/audi-s5-b8-4-2l-v8-ea824-quattro" }
      ]
    },
    "A6 • S6 • RS 6": {
      "C9 (2026+)": [
        { "title": "A6 3.0T V6 EA839e quattro", "url": "/collections/audi-a6-c9-3-0t-v6-ea839e-quattro" }
      ],
      "C8.2 (2024-2025)": [
        { "title": "A6 2.0T I4 EA888.4 quattro", "url": "/collections/audi-a6-c8-2-2-0t-i4-ea888-4-quattro" },
        { "title": "A6 3.0T V6 EA839 quattro", "url": "/collections/audi-a6-c8-2-3-0t-v6-ea839-quattro" },
        { "title": "A6 allroad 3.0T V6 EA839 quattro", "url": "/collections/audi-a6-allroad-c8-2-3-0t-v6-ea839-quattro" },
        { "title": "S6 2.9T V6 EA839 quattro", "url": "/collections/audi-s6-c8-2-2-9tt-v6-ea839-quattro" },
        { "title": "RS 6 Performance 4.0TT V8 EA825 quattro", "url": "/collections/audi-rs-6-performance-c8-2-4-0t-v8-ea825-quattro" }
      ],
      "C8 (2019-2023)": [
        { "title": "A6 2.0T I4 EA888.3 quattro", "url": "/collections/audi-a6-c8-2-0t-i4-ea888-3-quattro" },
        { "title": "A6 3.0T V6 EA839 quattro", "url": "/collections/audi-a6-c8-3-0t-v6-ea839-quattro" },
        { "title": "A6 allroad 3.0T V6 EA839 quattro", "url": "/collections/audi-a6-allroad-c8-3-0t-v6-ea839-quattro" },
        { "title": "S6 2.9TT V6 EA839 quattro", "url": "/collections/audi-s6-c8-2-9tt-v6-ea839-quattro" },
        { "title": "RS 6 4.0TT V8 EA825 quattro", "url": "/collections/audi-rs-6-c8-4-0t-v8-ea825-quattro" }
      ],
      "C7.2 (2016-2018)": [
        { "title": "A6 2.0T I4 EA888.3 FWD", "url": "/collections/audi-a6-c7-2-2-0t-i4-ea888-3-fwd" },
        { "title": "A6 2.0T I4 EA888.3 quattro", "url": "/collections/audi-a6-c7-2-2-0t-i4-ea888-3-quattro" },
        { "title": "A6 3.0S V6 EA837 quattro", "url": "/collections/audi-a6-c7-2-3-0s-v6-ea837-quattro" },
        { "title": "A6 3.0T TDI V6 EA897 quattro", "url": "/collections/audi-a6-c7-2-3-0t-tdi-v6-ea897-quattro" },
        { "title": "S6 4.0T V8 EA824 quattro", "url": "/collections/audi-s6-c7-2-4-0t-v8-ea824-quattro" }
      ],
      "C7 (2012-2015)": [
        { "title": "A6 2.0T I4 EA888.2 FWD", "url": "/collections/audi-a6-c7-2-0t-i4-ea888-2-fwd" },
        { "title": "A6 2.0T I4 EA888.2 quattro", "url": "/collections/audi-a6-c7-2-0t-i4-ea888-2-quattro" },
        { "title": "A6 3.0S V6 EA837 quattro", "url": "/collections/audi-a6-c7-3-0s-v6-ea837-quattro" },
        { "title": "A6 3.0T TDI V6 EA897 quattro", "url": "/collections/audi-a6-c7-3-0t-tdi-v6-ea897-quattro" },
        { "title": "S6 4.0T V8 EA824 quattro", "url": "/collections/audi-s6-c7-4-0t-v8-ea824-quattro" }
      ],
      "C6 (2005-2011)": [
        { "title": "A6 3.0S V6 EA837 quattro", "url": "/collections/audi-a6-c6-3-0s-v6-ea837-quattro" },
        { "title": "A6 3.2L V6 EA837 quattro", "url": "/collections/audi-a6-c6-3-2l-v6-ea837-quattro" },
        { "title": "A6 4.2L V8 EA824 quattro", "url": "/collections/audi-a6-c6-4-2l-v8-ea824-quattro" },
        { "title": "S6 5.2L V10 EA824 quattro", "url": "/collections/audi-s6-c6-5-2l-v10-ea824-quattro" },
        { "title": "RS 6 5.0T V10 EA824 quattro", "url": "/collections/audi-rs-6-c6-5-0t-v10-ea824-quattro" }
      ],
      "C5 (1998-2005)": [
        { "title": "A6 2.8L V6 EA835 quattro", "url": "/collections/audi-a6-c5-2-8l-v6-ea835-quattro" },
        { "title": "A6 3.0L V6 EA835 quattro", "url": "/collections/audi-a6-c5-3-0l-v6-ea835-quattro" },
        { "title": "A6 2.7T V6 EA835 quattro", "url": "/collections/audi-a6-c5-2-7t-v6-ea835-quattro" },
        { "title": "A6 4.2L V8 EA824 quattro", "url": "/collections/audi-a6-c5-4-2l-v8-ea824-quattro" },
        { "title": "S6 4.2L V8 EA824 quattro", "url": "/collections/audi-s6-c5-4-2l-v8-ea824-quattro" },
        { "title": "RS 6 4.2T V8 EA824 quattro", "url": "/collections/audi-rs-6-c5-4-2t-v8-ea824-quattro" }
      ]
    },
    "A7 • S7 • RS 7": {
      "C8.2 (2024-2025)": [
        { "title": "A7 3.0T V6 EA839 quattro", "url": "/collections/audi-a7-c8-2-3-0t-v6-ea839-quattro" },
        { "title": "S7 2.9TT V6 EA839 quattro", "url": "/collections/audi-s7-c8-2-2-9t-v6-ea839-quattro" },
        { "title": "RS 7 4.0TT V8 EA825 quattro", "url": "/collections/audi-rs-7-c8-2-4-0t-v8-ea825-quattro" }
      ],
      "C8 (2019-2023)": [
        { "title": "A7 3.0T V6 EA839 quattro", "url": "/collections/audi-a7-c8-3-0t-v6-ea839-quattro" },
        { "title": "S7 2.9TT V6 EA839 quattro", "url": "/collections/audi-s7-c8-2-9t-v6-ea839-quattro" },
        { "title": "RS 7 4.0TT V8 EA825 quattro", "url": "/collections/audi-rs-7-c8-4-0t-v8-ea825-quattro" },
        { "title": "RS 7 Performance 4.0TT V8 EA825 quattro", "url": "/collections/audi-rs-7-c8-4-0t-v8-ea825-quattro" }
      ],
      "C7.2 (2016-2018)": [
        { "title": "A7 3.0S V6 EA837 quattro", "url": "/collections/audi-a7-c7-3-0s-v6-ea837-quattro" },
        { "title": "A7 3.0T TDI V6 EA897 quattro", "url": "/collections/audi-a7-c7-3-0t-tdi-v6-ea897-quattro" },
        { "title": "S7 4.0T V8 EA824 quattro", "url": "/collections/audi-s7-c7-4-0l-v8-ea824-quattro" },
        { "title": "RS 7 4.0TT V8 EA824 quattro", "url": "/collections/audi-rs-7-c7-4-0tt-v8-ea824-quattro" },
        { "title": "RS 7 Performance 4.0TT V8 EA824 quattro", "url": "/collections/audi-rs-7-performance-c7-2-4-0tt-v8-ea824-quattro" }
      ],
      "C7 (2012-2015)": [
        { "title": "A7 3.0S V6 EA837 quattro", "url": "/collections/audi-a7-c7-3-0s-v6-ea837-quattro" },
        { "title": "A7 3.0T TDI V6 EA897 quattro", "url": "/collections/audi-a7-c7-3-0t-tdi-v6-ea897-quattro" },
        { "title": "S7 4.0T V8 EA824 quattro", "url": "/collections/audi-s7-c7-4-0l-v8-ea824-quattro" },
        { "title": "RS 7 4.0TT V8 EA824 quattro", "url": "/collections/audi-rs-7-c7-4-0tt-v8-ea824-quattro" }
      ]
    },
    "A8 • S8 • RS 8": {
      "D5.2 (2022+)": [
        { "title": "A8L 3.0T V6 EA839 quattro", "url": "/collections/audi-a8l-d5-3-0tv6-ea839-quattro" },
        { "title": "S8 4.0T V8 EA825 quattro", "url": "/collections/audi-s8-d5-2-4-0t-v8-ea825-quattro" }
      ],
      "D5 (2019-2021)": [
        { "title": "A8L 3.0T V6 EA839 quattro", "url": "/collections/audi-a8l-d5-3-0t-v6-ea839-quattro" },
        { "title": "A8L 4.0T V8 EA825 quattro", "url": "/collections/audi-a8l-d5-4-0t-v8-ea825-quattro" },
        { "title": "A8L 4.0T e V8 EA825 quattro", "url": "/collections/audi-a8l-d5-4-0t-e-v8-ea825-quattro" },
        { "title": "S8 4.0T V8 EA825 quattro", "url": "/collections/audi-s8-d5-4-0t-v8-ea825-quattro" }
      ]
    },
    "Q3": {
      "FJ (2026+)": [
        { "title": "Q3 2.0T I4 EA888.5 quattro", "url": "/collections/audi-q3-fj-2-0t-i4-ea888-5-quattro" }
      ],
      "F3 (2019-2025)": [
        { "title": "Q3 2.0T I4 EA888.4 quattro", "url": "/collections/audi-q3-f3-2-0t-i4-ea888-4-quattro" },
        { "title": "Q3 2.0T I4 EA888.3 quattro", "url": "/collections/audi-q3-f3-2-0t-i4-ea888-3-quattro" },
        { "title": "Q3 2.0T I4 EA888.3B quattro", "url": "/collections/audi-q3-f3-2-0t-i4-ea888-3b-quattro" }
      ],
      "8U (2015-2018)": [
        { "title": "Q3 2.0T I4 EA888.2 FWD", "url": "/collections/audi-q3-8u-2-0t-ea888-2-fwd" },
        { "title": "Q3 2.0T I4 EA888.2 quattro", "url": "/collections/audi-q3-8u-2-0t-ea888-2-quattro" }
      ]
    },
    "Q4 e-tron": {
      "F4 (2021+)": [
        { "title": "Q4 e-tron 82 kWh RWD", "url": "/collections/audi-q4-e-tron-f4-82-kwh-rwd" },
        { "title": "Q4 e-tron 82 kWh quattro", "url": "/collections/audi-q4-e-tron-f4-82-kwh-quattro" },
        { "title": "SQ4 e-tron 82 kWh quattro", "url": "/collections/audi-sq4-e-tron-f4-82-kwh-quattro" }
      ]
    },
    "Q5 • SQ5": {
      "B10 (2025+)": [
        { "title": "Q5 2.0T I4 EA888.5 quattro", "url": "/collections/audi-q5-b10-2-0t-i4-ea888-5-quattro" },
        { "title": "SQ5 3.0T V6 EA839e quattro", "url": "/collections/audi-sq5-b10-3-0t-v6-ea839e-quattro" }
      ],
      "B9.2 (2021-2024)": [
        { "title": "Q5 2.0T I4 EA888.4B quattro", "url": "/collections/audi-q5-b9-2-2-0t-i4-ea888-4b-quattro" },
        { "title": "Q5 2.0T I4 EA888.4 quattro", "url": "/collections/audi-q5-b9-2-2-0t-i4-ea888-4-quattro" },
        { "title": "Q5 e 2.0T I4 EA888.4 quattro", "url": "/collections/audi-q5-b9-2-2-0t-e-i4-ea888-4-quattro" },
        { "title": "SQ5 3.0T V6 EA839e quattro", "url": "/collections/audi-sq5-b9-2-3-0t-v6-ea839e-quattro" }
      ],
      "B9 (2018-2020)": [
        { "title": "Q5 2.0T I4 EA888.3 quattro", "url": "/collections/audi-q5-b9-2-0t-i4-ea888-3-quattro" },
        { "title": "Q5 e 2.0T I4 EA888.3 quattro", "url": "/collections/audi-q5-b9-2-2-0t-e-i4-ea888-3-quattro" },
        { "title": "SQ5 3.0T V6 EA839 quattro", "url": "/collections/audi-sq5-b9-2-3-0t-v6-ea839-quattro" }
      ],
      "B8.2 (2013-2017)": [
        { "title": "Q5 2.0T I4 EA888.2 quattro", "url": "/collections/audi-q5-b8-2-2-0t-i4-ea888-2-quattro" },
        { "title": "Q5 2.0T I4 EA888.3 quattro", "url": "/collections/audi-q5-b8-2-2-0t-i4-ea888-3-quattro" },
        { "title": "Q5 3.0S V6 EA837 quattro", "url": "/collections/audi-q5-b8-2-3-0s-v6-ea837-quattro" },
        { "title": "Q5 3.0T V6 TDI EA897 quattro", "url": "/collections/audi-q5-b8-2-3-0t-v6-tdi-ea897-quattro" },
        { "title": "SQ5 3.0S V6 EA837 quattro", "url": "/collections/audi-sq5-b8-2-3-0s-v6-ea837-quattro" }
      ],
      "B8 (2009-2012)": [
        { "title": "Q5 2.0T I4 EA888.2 quattro", "url": "/collections/audi-q5-b8-2-0t-i4-ea888-2-quattro" },
        { "title": "Q5 3.2L V6 EA837 quattro", "url": "/collections/audi-q5-b8-3-2l-v6-ea837-quattro" }
      ]
    },
    "Q7 • SQ7": {
      "4M.3 (2025+)": [
        { "title": "Q7 2.0T I4 EA888.4 quattro", "url": "/collections/audi-q7-4m-3-2-0t-i4-ea888-4-quattro" },
        { "title": "Q7 3.0T V6 EA839 quattro", "url": "/collections/audi-q7-4m-3-3-0t-v6-ea839-quattro" },
        { "title": "SQ7 4.0TT V8 EA825 quattro", "url": "/collections/audi-sq7-4m-3-4-0t-v8-ea825-quattro" }
      ],
      "4M.2 (2020-2024)": [
        { "title": "Q7 2.0T I4 EA888.4 quattro", "url": "/collections/audi-q7-4m-2-2-0t-i4-ea888-4-quattro" },
        { "title": "Q7 3.0T V6 EA839 quattro", "url": "/collections/audi-q7-4m-2-3-0t-v6-ea839-quattro" },
        { "title": "SQ7 4.0TT V8 EA825 quattro", "url": "/collections/audi-sq7-4m-2-4-0t-v8-ea825-quattro" }
      ],
      "4M (2017-2019)": [
        { "title": "Q7 2.0T I4 EA888.3 quattro", "url": "/collections/audi-q7-4m-2-0t-i4-ea888-3-quattro" },
        { "title": "Q7 3.0S V6 EA837 quattro", "url": "/collections/audi-q7-4m-3-0s-v6-ea837-quattro" }
      ],
      "4L (2007-2016)": [
        { "title": "Q7 3.0S V6 EA837 quattro", "url": "/collections/audi-q7-4l-3-0s-v6-ea837-quattro" },
        { "title": "Q7 3.6L VR6 EA390 quattro", "url": "/collections/audi-q7-4l-3-6l-vr6-ea390-quattro" },
        { "title": "Q7 4.2L V8 EA824 quattro", "url": "/collections/audi-q7-4l-4-2l-v8-ea824-quattro" }
      ]
    },
    "Q8 • SQ8 • RS Q8": {
      "4M.2 (2024+)": [
        { "title": "Q8 3.0T V6 EA839 quattro", "url": "/collections/audi-q8-4m-2-3-0t-v6-ea839-quattro" },
        { "title": "SQ8 4.0TT V8 EA825 quattro", "url": "/collections/audi-sq8-4m-2-4-0t-v8-ea825-quattro" },
        { "title": "RS Q8 4.0TT V8 EA825 quattro", "url": "/collections/audi-rs-q8-4m-2-4-0l-tfsi-quattro" },
        { "title": "RS Q8 Performance 4.0TT V8 EA825 quattro", "url": "/collections/audi-rs-q8-performance-4m-2-4-0l-tfsi-quattro" }
      ],
      "4M (2019-2023)": [
        { "title": "Q8 3.0T V6 EA839 quattro", "url": "/collections/audi-q8-4m-3-0t-v6-ea839-quattro" },
        { "title": "SQ8 4.0TT V8 EA825 quattro", "url": "/collections/audi-sq8-4m-4-0t-v8-ea825-quattro" },
        { "title": "RS Q8 4.0TT V8 EA825 quattro", "url": "/collections/audi-rs-q8-4m-4-0l-tfsi-quattro" }
      ]
    },
    "R8": {
      "4S.2 (2019-2024)": [
        { "title": "5.2L V10 quattro", "url": "/collections/audi-r8-4s-2-5-2l-v10-quattro" },
        { "title": "5.2L V10 RWD", "url": "/collections/audi-r8-4s-2-5-2l-v10-rwd" },
        { "title": "GT 5.2L V10 RWD", "url": "/collections/audi-r8-gt-4s-2-5-2l-v10-rwd" }
      ],
      "4S (2016-2018)": [
        { "title": "Plus 5.2L V10 quattro", "url": "/collections/audi-r8-plus-4s-5-2l-v10-quattro" },
        { "title": "5.2L V10 quattro", "url": "/collections/audi-r8-4s-5-2l-v10-quattro" },
        { "title": "5.2L V10 RWS", "url": "/collections/audi-r8-4s-5-2l-v10-rws" }
      ],
      "42 (2007-2015)": [
        { "title": "4.2L V8 EA824 quattro", "url": "/collections/audi-r8-42-4-2l-v8-ea824-quattro" },
        { "title": "5.2L V10 EA824 quattro", "url": "/collections/audi-r8-42-5-2l-v10-ea824-quattro" }
      ]
    },
    "TT • TTS • TT RS": {
      "8S.2 (2018-2023)": [
        { "title": "TT 2.0T I4 EA888.4 quattro", "url": "/collections/audi-tt-8s-2-2-0t-i4-ea888-4-quattro" },
        { "title": "TT 2.0T I4 EA888.3 quattro", "url": "/collections/audi-tt-8s-2-2-0t-i4-ea888-3-quattro" },
        { "title": "TTS 2.0T I4 EA888.3 quattro", "url": "/collections/audi-tts-8s-2-2-0t-i4-ea888-3-quattro" },
        { "title": "TT RS 2.5T I5 EA855e quattro", "url": "/collections/audi-tt-rs-8s-2-2-5t-i5-ea855e-quattro" }
      ],
      "8S (2016-2017)": [
        { "title": "TT 2.0T I4 EA888.3 quattro", "url": "/collections/audi-tt-8s-2-0t-i4-ea888-3-quattro" },
        { "title": "TTS 2.0T I4 EA888.3 quattro", "url": "/collections/audi-tts-8s-2-0t-i4-ea888-3-quattro" },
        { "title": "TT RS 2.5T I5 EA855e quattro", "url": "/collections/audi-tt-rs-8s-2-5t-i5-ea855e-quattro" }
      ],
      "8J (2006-2015)": [
        { "title": "TT 2.0T I4 EA113 FWD", "url": "/collections/audi-tt-8j-2-0t-i4-ea113-fwd" },
        { "title": "TT 2.0T I4 EA888.1 quattro", "url": "/collections/audi-tt-8j-2-0t-i4-ea888-1-quattro" },
        { "title": "TT 2.0T I4 EA888.2 quattro", "url": "/collections/audi-tt-8j-2-0t-i4-ea888-2-quattro" },
        { "title": "TT 3.2L VR6 EA390 quattro", "url": "/collections/audi-tt-8j-3-2l-vr6-ea390-quattro" },
        { "title": "TTS 2.0T I4 EA113 quattro", "url": "/collections/audi-tts-8j-2-0t-i4-ea113-quattro" },
        { "title": "TT RS 2.5T I5 EA855 quattro", "url": "/collections/audi-tt-rs-8j-2-5t-i5-ea855-quattro" }
      ],
      "8N (1998-2007)": [
        { "title": "TT 1.8T I4 EA113 FWD", "url": "/collections/audi-tt-8n-1-8t-i4-ea113-fwd" },
        { "title": "TT 1.8T I4 EA113 180HP quattro", "url": "/collections/audi-tt-8n-1-8t-i4-ea113-180hp-quattro" },
        { "title": "TT 1.8T I4 EA113 225HP quattro", "url": "/collections/audi-tt-8n-1-8t-i4-ea113-225hp-quattro" },
        { "title": "TT 3.2L VR6 EA390 quattro", "url": "/collections/audi-tt-8n-3-2l-vr6-ea390-quattro" }
      ]
    }
  },
  "BMW": {
    "2-Series": {
      "G87 LCI (2025+)": [
        { "title": "M2 3.0TT I6 S58 RWD", "url": "/collections/bmw-m2-g87-lci-3-0tt-i6-s58-rwd" },
        { "title": "M2 CS 3.0TT I6 S58 RWD", "url": "/collections/bmw-m2-cs-g87-lci-3-0tt-i6-s58-rwd" }
      ],
      "G42 LCI (2025+)": [
        { "title": "230i 2.0T I4 B48O sDrive", "url": "/collections/bmw-230i-g42-lci-2-0t-i4-b48o-sdrive" },
        { "title": "230i 2.0T I4 B48O xDrive", "url": "/collections/bmw-230i-g42-lci-2-0t-i4-b48o-xdrive" },
        { "title": "M240i 3.0T I6 B58O sDrive", "url": "/collections/bmw-m240i-g42-lci-3-0t-i6-b58o-sdrive" },
        { "title": "M240i 3.0T I6 B58O xDrive", "url": "/collections/bmw-m240i-g42-lci-3-0t-i6-b58o-xdrive" }
      ],
      "G87 (2023-2024)": [
        { "title": "M2 3.0TT I6 S58 RWD", "url": "/collections/bmw-m2-g87-3-0t-i6-s58-rwd" }
      ],
      "G42 (2022-2024)": [
        { "title": "230i 2.0T I4 B46O sDrive", "url": "/collections/bmw-230i-g42-2-0t-i4-b46o-sdrive" },
        { "title": "230i 2.0T I4 B46O xDrive", "url": "/collections/bmw-230i-g42-2-0t-i4-b46o-xdrive" },
        { "title": "M240i 3.0T I6 B58O sDrive", "url": "/collections/bmw-m240i-g42-3-0t-i6-b58o-sdrive" },
        { "title": "M240i 3.0T I6 B58O xDrive", "url": "/collections/bmw-m240i-g42-3-0t-i6-b58o-xdrive" }
      ],
      "F74 (2025+)": [
        { "title": "228 GC 2.0T I4 B48P sDrive", "url": "/collections/bmw-228-gran-coupe-f74-2-0t-i4-b48p-sdrive" },
        { "title": "228 GC 2.0T I4 B48P xDrive", "url": "/collections/bmw-228-gran-coupe-f74-2-0t-i4-b48p-xdrive" },
        { "title": "M235 GC 2.0T I4 B48T xDrive", "url": "/collections/bmw-m235-gran-coupe-f74-2-0t-i4-b48t-xdrive" }
      ],
      "F87 LCI (2018-2021)": [
        { "title": "M2 Competition 3.0TT I6 S55 RWD", "url": "/collections/bmw-m2-competition-f87-lci-3-0tt-i6-s55-rwd" },
        { "title": "M2 CS 3.0TT I6 S55 RWD", "url": "/collections/bmw-m2-cs-f87-lci-3-0tt-i6-s55-rwd" }
      ],
      "F87 (2016-2017)": [
        { "title": "M2 3.0T I6 N55 RWD", "url": "/collections/bmw-m2-f87-3-0t-i6-n55-rwd" }
      ],
      "F44 (2020-2024)": [
        { "title": "228i GC 2.0T I4 B46O sDrive", "url": "/collections/bmw-228i-gran-coupe-f44-2-0t-i4-b46o-sdrive" },
        { "title": "228i GC 2.0T I4 B46O xDrive", "url": "/collections/bmw-228i-gran-coupe-f44-2-0t-i4-b46o-xdrive" },
        { "title": "M235i GC 2.0T I4 B48T xDrive", "url": "/collections/bmw-m235i-gran-coupe-f44-2-0t-i4-b48t-xdrive" }
      ],
      "F22 • F23 (2014-2021)": [
        { "title": "228i 2.0T I4 N20 sDrive", "url": "/collections/bmw-228i-f22-f23-2-0t-i4-n20-sdrive" },
        { "title": "228i 2.0T I4 N20 xDrive", "url": "/collections/bmw-228i-f22-f23-2-0t-i4-n20-xdrive" },
        { "title": "228i 2.0T I4 N26 sDrive", "url": "/collections/bmw-228i-f22-f23-2-0t-i4-n26-sdrive" },
        { "title": "228i 2.0T I4 N26 xDrive", "url": "/collections/bmw-228i-f22-f23-2-0t-i4-n26-xdrive" },
        { "title": "230i 2.0T I4 B46O sDrive", "url": "/collections/bmw-230i-f22-f23-2-0t-i4-b46o-sdrive" },
        { "title": "230i 2.0T I4 B46O xDrive", "url": "/collections/bmw-230i-f22-f23-2-0t-i4-b46o-xdrive" },
        { "title": "M235i 3.0T I6 N55 sDrive", "url": "/collections/bmw-m235i-f22-f23-3-0t-i6-n55-sdrive" },
        { "title": "M235i 3.0T I6 N55 xDrive", "url": "/collections/bmw-m235i-f22-f23-3-0t-i6-n55-xdrive" },
        { "title": "M240i 3.0T I6 B58O sDrive", "url": "/collections/bmw-m240i-f22-f23-3-0t-i6-b58o-sdrive" },
        { "title": "M240i 3.0T I6 B58O xDrive", "url": "/collections/bmw-m240i-f22-f23-3-0t-i6-b58o-xdrive" }
      ]
    },
    "3-Series": {
      "G80 LCI (2025+)": [
        { "title": "M3 3.0TT I6 S58 RWD", "url": "/collections/bmw-m3-g80-lci-3-0tt-i6-s58-rwd" },
        { "title": "M3 Competition 3.0TT I6 S58 RWD", "url": "/collections/bmw-m3-competition-g80-lci-3-0tt-i6-s58-rwd" },
        { "title": "M3 Competition 3.0TT I6 S58 xDrive", "url": "/collections/bmw-m3-competition-g80-lci-3-0tt-i6-s58-xdrive" }
      ],
      "G80 (2021-2024)": [
        { "title": "M3 3.0TT I6 S58 RWD", "url": "/collections/bmw-m3-g80-3-0tt-i6-s58-rwd" },
        { "title": "M3 Competition 3.0TT I6 S58 RWD", "url": "/collections/bmw-m3-competition-g80-3-0tt-i6-s58-rwd" },
        { "title": "M3 Competition 3.0TT I6 S58 xDrive", "url": "/collections/bmw-m3-competition-g80-3-0tt-i6-s58-xdrive" },
        { "title": "M3 CS 3.0TT I6 S58 xDrive", "url": "/collections/bmw-m3-cs-g80-3-0tt-i6-s58-xdrive" }
      ],
      "G20 LCI2 (2025+)": [
        { "title": "330i 2.0T I4 B48O sDrive", "url": "/collections/bmw-330i-g20-lci2-2-0t-i4-b48o-sdrive" },
        { "title": "330i 2.0T I4 B48O xDrive", "url": "/collections/bmw-330i-g20-lci2-2-0t-i4-b48o-xdrive" },
        { "title": "M340i 3.0T I6 B58M sDrive", "url": "/collections/bmw-m340i-g20-lci-3-0t-i6-b58m-sdrive" },
        { "title": "M340i 3.0T I6 B58M xDrive", "url": "/collections/bmw-m340i-g20-lci-3-0t-i6-b58m-xdrive" }
      ],
      "G20 LCI (2023-2024)": [
        { "title": "330i 2.0T I4 B46O sDrive", "url": "/collections/bmw-330i-g20-lci-2-0t-i4-b46o-sdrive" },
        { "title": "330i 2.0T I4 B46O xDrive", "url": "/collections/bmw-330i-g20-lci-2-0t-i4-b46o-xdrive" },
        { "title": "M340i 3.0T I6 B58O sDrive", "url": "/collections/bmw-m340i-g20-lci-3-0t-i4-b58o-sdrive" },
        { "title": "M340i 3.0T I6 B58O xDrive", "url": "/collections/bmw-m340i-g20-lci-3-0t-i4-b58o-xdrive" }
      ],
      "G20 (2019-2022)": [
        { "title": "330i 2.0T I4 B46O sDrive", "url": "/collections/bmw-330i-g20-2-0t-i4-b46o-sdrive" },
        { "title": "330i 2.0T I4 B46O xDrive", "url": "/collections/bmw-330i-g20-2-0t-i4-b46o-xdrive" },
        { "title": "M340i 3.0T I6 B58O sDrive", "url": "/collections/bmw-m340i-g20-3-0t-i6-b58o-sdrive" },
        { "title": "M340i 3.0T I6 B58O xDrive", "url": "/collections/bmw-m340i-g20-3-0t-i6-b58o-xdrive" }
      ],
      "F80 LCI (2016-2018)": [
        { "title": "M3 Competition 3.0TT I6 S55 RWD", "url": "/collections/bmw-m3-competition-f80-lci-3-0tt-i6-s55-rwd" },
        { "title": "M3 CS 3.0TT I6 S55 RWD", "url": "/collections/bmw-m3-cs-f80-lci-3-0tt-i6-s55-rwd" }
      ],
      "F80 (2015)": [
        { "title": "M3 3.0TT I6 S55 RWD", "url": "/collections/bmw-m3-f80-3-0tt-i6-s55-rwd" }
      ],
      "F30 LCI (2016-2018)": [
        { "title": "330i 2.0T I4 B48O sDrive", "url": "/collections/bmw-330i-f30-lci-2-0t-i4-b48o-sdrive" },
        { "title": "330i 2.0T I4 B48O xDrive", "url": "/collections/bmw-330i-f30-lci-2-0t-i4-b48o-xdrive" },
        { "title": "330e 2.0T I4 B48O sDrive", "url": "/collections/bmw-330e-f30-lci-2-0t-i4-b48o-sdrive" },
        { "title": "340i 3.0T I6 B58O sDrive", "url": "/collections/bmw-340i-f30-lci-3-0t-i6-b58o-sdrive" },
        { "title": "340i 3.0T I6 B58O xDrive", "url": "/collections/bmw-340i-f30-lci-3-0t-i6-b58o-xdrive" }
      ],
      "F30 (2013-2017)": [
        { "title": "320i 2.0T I4 N20 sDrive", "url": "/collections/bmw-320i-f30-2-0t-i4-n20-sdrive" },
        { "title": "320i 2.0T I4 N20 xDrive", "url": "/collections/bmw-320i-f30-2-0t-i4-n20-xdrive" },
        { "title": "328i 2.0T I4 N26 sDrive", "url": "/collections/bmw-328i-f30-2-0t-i4-n26-sdrive" },
        { "title": "328i 2.0T I4 N26 xDrive", "url": "/collections/bmw-328i-f30-2-0t-i4-n26-xdrive" },
        { "title": "328d 2.0T I4 N47 sDrive", "url": "/collections/bmw-328d-f30-2-0t-i4-n47-sdrive" },
        { "title": "328d 2.0T I4 N47 xDrive", "url": "/collections/bmw-328d-f30-2-0t-i4-n47-xdrive" },
        { "title": "335i 3.0T I6 N55 sDrive", "url": "/collections/bmw-335i-f30-3-0t-i6-n55-sdrive" },
        { "title": "335i 3.0T I6 N55 xDrive", "url": "/collections/bmw-335i-f30-3-0t-i6-n55-xdrive" }
      ]
    },
    "4-Series": {
      "G82 • G83 LCI (2025+)": [
        { "title": "M4 3.0TT I6 S58 RWD", "url": "/collections/bmw-m4-g82-g83-lci-3-0tt-i6-s58-rwd" },
        { "title": "M4 Competition 3.0TT I6 S58 RWD", "url": "/collections/bmw-m4-competition-g82-g83-lci-3-0tt-i6-s58-rwd" },
        { "title": "M4 Competition 3.0TT I6 S58 xDrive", "url": "/collections/bmw-m4-competition-g82-g83-lci-3-0tt-i6-s58-xdrive" },
        { "title": "M4 CS 3.0TT I6 S58 xDrive", "url": "/collections/bmw-m4-cs-g82-g83-lci-3-0tt-i6-s58-xdrive" }
      ],
      "G82 • G83 (2021-2024)": [
        { "title": "M4 3.0TT I6 S58 RWD", "url": "/collections/bmw-m4-g82-g83-3-0tt-i6-s58-rwd" },
        { "title": "M4 Competition 3.0TT I6 S58 RWD", "url": "/collections/bmw-m4-competition-g82-g83-3-0tt-i6-s58-rwd" },
        { "title": "M4 Competition 3.0TT I6 S58 xDrive", "url": "/collections/bmw-m4-competition-g82-g83-3-0tt-i6-s58-xdrive" },
        { "title": "M4 CSL 3.0TT I6 S58 RWD", "url": "/collections/bmw-m4-csl-g82-3-0tt-i6-s58-rwd" }
      ],
      "G22 • G23 • G26 LCI (2025+)": [
        { "title": "430i 2.0T I4 B48P sDrive", "url": "/collections/bmw-430i-g22-g23-g26-lci-2-0t-i4-b48p-sdrive" },
        { "title": "430i 2.0T I4 B48P xDrive", "url": "/collections/bmw-430i-g22-g23-g26-lci-2-0t-i4-b48p-xdrive" },
        { "title": "M440i 3.0T I6 B58M sDrive", "url": "/collections/bmw-m440i-g22-g23-g26-lci-3-0t-i6-b58m-sdrive" },
        { "title": "M440i 3.0T I6 B58M xDrive", "url": "/collections/bmw-m440i-g22-g23-g26-lci-3-0t-i6-b58m-xdrive" }
      ],
      "G22 • G23 • G26 (2021-2024)": [
        { "title": "430i 2.0T I4 B46O sDrive", "url": "/collections/bmw-430i-g22-g23-g26-2-0t-i4-b46o-sdrive" },
        { "title": "430i 2.0T I4 B46O xDrive", "url": "/collections/bmw-430i-g22-g23-g26-2-0t-i4-b46o-xdrive" },
        { "title": "M440i 3.0T I6 B58O sDrive", "url": "/collections/bmw-m440i-g22-g23-g26-3-0t-i6-b58o-sdrive" },
        { "title": "M440i 3.0T I6 B58O xDrive", "url": "/collections/bmw-m440i-g22-g23-g26-3-0t-i6-b58o-xdrive" }
      ],
      "F32 • F33 • F36 LCI (2018-2020)": [
        { "title": "430i 2.0T I4 B48O sDrive", "url": "/collections/bmw-430i-f32-f33-f36-lci-2-0t-i4-b48o-sdrive" },
        { "title": "430i 2.0T I4 B48O xDrive", "url": "/collections/bmw-430i-f32-f33-f36-lci-2-0t-i4-b48o-xdrive" },
        { "title": "440i 3.0T I6 B58O sDrive", "url": "/collections/bmw-440i-f32-f33-f36-lci-3-0t-i6-b58o-sdrive" },
        { "title": "440i 3.0T I6 B58O xDrive", "url": "/collections/bmw-440i-f32-f33-f36-lci-3-0t-i6-b58o-xdrive" }
      ],
      "F32 • F33 • F36 (2014-2017)": [
        { "title": "428i 2.0T I4 N20 sDrive", "url": "/collections/bmw-428i-f32-f33-f36-2-0t-i4-n20-sdrive" },
        { "title": "428i 2.0T I4 N20 xDrive", "url": "/collections/bmw-428i-f32-f33-f36-2-0t-i4-n20-xdrive" },
        { "title": "428i 2.0T I4 N26 sDrive", "url": "/collections/bmw-428i-f32-f33-f36-2-0t-i4-n26-sdrive" },
        { "title": "428i 2.0T I4 N26 xDrive", "url": "/collections/bmw-428i-f32-f33-f36-2-0t-i4-n26-xdrive" },
        { "title": "435i 3.0T I6 N55 sDrive", "url": "/collections/bmw-435i-f32-f33-f36-3-0t-i6-n55-sdrive" },
        { "title": "435i 3.0T I6 N55 xDrive", "url": "/collections/bmw-435i-f32-f33-f36-3-0t-i6-n55-xdrive" }
      ],
      "F82/F83 LCI (2018-2020)": [
        { "title": "M4 3.0TT I6 S55 RWD", "url": "/collections/bmw-m4-f82-f83-lci-3-0tt-i6-s55-rwd" },
        { "title": "M4 Competition 3.0TT I6 S55 RWD", "url": "/collections/bmw-m4-competition-f82-f83-lci-3-0tt-i6-s55-rwd" },
        { "title": "M4 CS 3.0TT I6 S55 RWD", "url": "/collections/bmw-m4-cs-f82-f83-lci-3-0tt-i6-s55-rwd" }
      ],
      "F82/F83 (2015-2017)": [
        { "title": "M4 3.0TT I6 S55 RWD", "url": "/collections/bmw-m4-f82-f83-3-0tt-i6-s55-rwd" },
        { "title": "M4 GTS 3.0TT I6 S55 RWD", "url": "/collections/bmw-m4-gts-f82-f83-3-0tt-i6-s55-rwd" }
      ]
    },
    "X1": {
      "U11 (2023+)": [
        { "title": "xDrive28i 2.0T I4 B48P", "url": "/collections/bmw-x1-xdrive28i-u11-2-0t-i4-b48p" },
        { "title": "M35i xDrive 2.0T I4 B48T", "url": "/collections/bmw-x1-m35i-xdrive-u11-2-0t-i4-b48t" }
      ],
      "F48 LCI (2020-2022)": [
        { "title": "sDrive28i 2.0T I4 B46O", "url": "/collections/bmw-x1-sdrive28i-f48-lci-2-0t-i4-b46o" },
        { "title": "xDrive28i 2.0T I4 B46O", "url": "/collections/bmw-x1-xdrive28i-f48-lci-2-0t-i4-b46o" }
      ],
      "F48 (2016-2019)": [
        { "title": "sDrive28i 2.0T I4 B46O", "url": "/collections/bmw-x1-sdrive28i-f48-2-0t-i4-b46o" },
        { "title": "xDrive28i 2.0T I4 B46O", "url": "/collections/bmw-x1-xdrive28i-f48-2-0t-i4-b46o" }
      ]
    },
    "X2": {
      "U10 (2024+)": [
        { "title": "xDrive28i 2.0T I4 B48P", "url": "/collections/bmw-x2-xdrive28i-u10-2-0t-i4-b48p" },
        { "title": "M35i xDrive 2.0T I4 B48T", "url": "/collections/bmw-x2-m35i-xdrive-u10-2-0t-i4-b48t" }
      ],
      "F39 (2018-2023)": [
        { "title": "sDrive28i 2.0T I4 B46O", "url": "/collections/bmw-x2-sdrive28i-f39-2-0t-i4-b46o" },
        { "title": "xDrive28i 2.0T I4 B46O", "url": "/collections/bmw-x2-xdrive28i-f39-2-0t-i4-b46o" },
        { "title": "M35i xDrive 2.0T I4 B48T", "url": "/collections/bmw-x2-m35i-xdrive-f39-2-0t-i4-b48t" }
      ]
    },
    "X3": {
      "G45 (2025+)": [
        { "title": "30 xDrive 2.0T I4 B48O", "url": "/collections/bmw-x3-30-xdrive-g45-2-0t-i4-b48o" },
        { "title": "M50 xDrive 3.0T I6 B58M", "url": "/collections/bmw-x3-m50-xdrive-g45-3-0t-i6-b58m" }
      ],
      "G01 LCI (2022-2024)": [
        { "title": "xDrive30i 2.0T I4 B46O", "url": "/collections/bmw-x3-xdrive30i-g01-lci-2-0t-i4-b46o" },
        { "title": "M40i xDrive 3.0T I6 B58O", "url": "/collections/bmw-x3-m40i-xdrive-g01-lci-3-0t-i6-b58o" }
      ],
      "G01 (2018-2021)": [
        { "title": "xDrive30i 2.0T I4 B46O", "url": "/collections/bmw-x3-xdrive30i-g01-2-0t-b46o" },
        { "title": "xDrive30e 2.0T I4 B46O", "url": "/collections/bmw-x3-xdrive30e-g01-2-0t-b46o" },
        { "title": "M40i xDrive 3.0T I6 B58O", "url": "/collections/bmw-x3-m40i-xdrive-g01-3-0t-i6-b58o" }
      ],
      "F97 LCI (2022-2024)": [
        { "title": "X3 M Competition xDrive 3.0T I6 S58", "url": "/collections/bmw-x3-m-competition-x-drive-f97-lci-3-0t-i6-s58" }
      ],
      "F97 (2020-2021)": [
        { "title": "X3 M xDrive 3.0T I6 S58", "url": "/collections/bmw-x3-m-x-drive-f97-3-0t-i6-s58" },
        { "title": "X3 M Competition xDrive 3.0T I6 S58", "url": "/collections/bmw-x3-m-competition-x-drive-f97-3-0t-i6-s58" }
      ],
      "F25 LCI (2015-2017)": [
        { "title": "sDrive28i 2.0T I4 N20", "url": "/collections/bmw-x3-sdrive28i-f25-lci-2-0t-i4-n20" },
        { "title": "xDrive35i 3.0T I6 N55", "url": "/collections/bmw-x3-xdrive35i-f25-lci-3-0t-i6-n55" }
      ],
      "F25 (2011-2014)": [
        { "title": "xDrive28i 2.0T I4 N20", "url": "/collections/bmw-x3-xdrive28i-f25-2-0t-i4-n20" },
        { "title": "xDrive28i 3.0T I6 N52", "url": "/collections/bmw-x3-xdrive28i-f25-3-0t-i6-n52" }
      ]
    },
    "X4": {
      "G02 LCI (2022-2025)": [
        { "title": "xDrive30i 2.0T I4 B46O", "url": "/collections/bmw-x4-xdrive30i-g02-lci-2-0t-i4-b46o" },
        { "title": "M40i xDrive 3.0T I6 B58O", "url": "/collections/bmw-x4-m40i-xdrive-g02-lci-3-0t-i6-b58o" }
      ],
      "G02 (2019-2021)": [
        { "title": "xDrive30i 2.0T I4 B46O", "url": "/collections/bmw-x4-xdrive30i-g02-2-0t-i4-b46o" },
        { "title": "M40i xDrive 3.0T I6 B58O", "url": "/collections/bmw-x4-m40i-xdrive-g02-3-0t-i6-b58o" }
      ],
      "F98 LCI (2022-2025)": [
        { "title": "X4 M xDrive 3.0T I6 S58", "url": "/collections/bmw-x4-m-xdrive-f98-lci-3-0t-i6-s58" },
        { "title": "X4 M Competition xDrive 3.0T I6 S58", "url": "/collections/bmw-x4-m-competition-xdrive-f98-lci-3-0t-i6-s58" }
      ],
      "F98 (2020-2021)": [
        { "title": "X4 M xDrive 3.0T I6 S58", "url": "/collections/bmw-x4-m-xdrive-f98-3-0t-i6-s58" },
        { "title": "X4 M Competition xDrive 3.0T I6 S58", "url": "/collections/bmw-x4-m-competition-xdrive-f98-3-0t-i6-s58" }
      ],
      "F26 (2015-2018)": [
        { "title": "xDrive28i 2.0T I4 N20", "url": "/collections/bmw-x4-xdrive28i-f26-2-0t-i4-n20" },
        { "title": "xDrive35i 3.0T I6 N55", "url": "/collections/bmw-x4-xdrive35i-f26-3-0t-i6-n55" },
        { "title": "M40i xDrive 3.0T I6 N55", "url": "/collections/bmw-x4-m40i-xdrive-f26-3-0t-i6-n55" }
      ]
    },
    "Z4": {
      "G29 (2019+)": [
        { "title": "sDrive30i 2.0T I4 B46O", "url": "/collections/bmw-z4-sdrive30i-g29-2-0t-i4-b46" },
        { "title": "M40i sDrive 3.0T I6 B58O", "url": "/collections/bmw-z4-m40i-sdrive-g29-3-0t-i6-b58o" }
      ]
    }
  },
  "Fiat": {
    "500": {
      "Type 312 (2012+)": [
        { "title": "1.4L", "url": "/collections/fiat-500-type-312-1-4l" },
        { "title": "Turbo 1.4T", "url": "/collections/fiat-500-turbo-type-312-1-4t" },
        { "title": "Abarth 1.4T", "url": "/collections/fiat-500-abarth-type-312-1-4t" }
      ]
    }
  },
  "Ford": {
    "Focus": {
      "Mk3 (2011-2018)": [
        { "title": "RS 2.3L EcoBoost", "url": "/collections/ford-focus-rs-mk3-2-3t-i4-ecoboost-awd" }
      ]
    }
  },
  "MINI": {
    "Clubman": {
      "F54 LCI (2020-2024)": [
        { "title": "Cooper S 2.0T I4 B46O FWD", "url": "/collections/mini-clubman-cooper-s-f54-lci-2-0t-i4-b46o-fwd" },
        { "title": "Cooper S 2.0T I4 B46O ALL4", "url": "/collections/mini-clubman-cooper-s-f54-lci-2-0t-i4-b46o-all4" },
        { "title": "JCW 2.0T I4 B48T ALL4", "url": "/collections/mini-clubman-jcw-f54-lci-2-0t-i4-b48t-all4" }
      ],
      "F54 (2016-2019)": [
        { "title": "Cooper 1.5T I3 B38M FWD", "url": "/collections/mini-clubman-cooper-f54-1-5t-i3-b38m-fwd" },
        { "title": "Cooper 1.5T I3 B38M ALL4", "url": "/collections/mini-clubman-cooper-f54-1-5t-i3-b38m-all4" },
        { "title": "Cooper S 2.0T I4 B46M FWD", "url": "/collections/mini-clubman-cooper-s-f54-2-0t-i4-b46m-fwd" },
        { "title": "Cooper S 2.0T I4 B46M ALL4", "url": "/collections/mini-clubman-cooper-s-f54-2-0t-i4-b46m-all4" },
        { "title": "JCW 2.0T I4 B48T ALL4", "url": "/collections/mini-clubman-jcw-f54-2-0t-i4-b48t-all4" }
      ],
      "R55 LCI (2011-2014)": [
        { "title": "Cooper 1.6L I4 N16 FWD", "url": "/collections/mini-clubman-cooper-r55-lci-1-6l-i4-n16-fwd" },
        { "title": "Cooper S 1.6T I4 N18 FWD", "url": "/collections/mini-clubman-cooper-s-r55-lci-1-6t-i4-n18-fwd" },
        { "title": "JCW 1.6T I4 N14 FWD", "url": "/collections/mini-clubman-jcw-r55-lci-1-6t-i4-n14-fwd" },
        { "title": "JCW 1.6T I4 N18 FWD", "url": "/collections/mini-clubman-jcw-r55-lci-1-6t-i4-n18-fwd" }
      ],
      "R55 (2008-2010)": [
        { "title": "Cooper 1.6L I4 N12 FWD", "url": "/collections/mini-clubman-cooper-r55-1-6l-i4-n12-fwd" },
        { "title": "Cooper S 1.6T I4 N14 FWD", "url": "/collections/mini-clubman-cooper-s-r55-1-6t-i4-n14-fwd" },
        { "title": "JCW 1.6T I4 N14 FWD", "url": "/collections/mini-clubman-jcw-r55-1-6t-i4-n14-fwd" }
      ]
    },
    "Convertible": {
      "F67 (2025+)": [
        { "title": "Cooper C 1.5T I3 B38M FWD", "url": "/collections/mini-convertible-cooper-c-f67-1-5t-i3-b38m-fwd" },
        { "title": "Cooper S 2.0T I4 B48O FWD", "url": "/collections/mini-convertible-cooper-s-f67-2-0t-i4-b48o-fwd" },
        { "title": "JCW 2.0T I4 B48T FWD", "url": "/collections/mini-convertible-jcw-f67-2-0t-i4-b48t-fwd" }
      ],
      "F57 LCI2 (2022-2024)": [
        { "title": "Cooper 1.5T I3 B38M FWD", "url": "/collections/mini-convertible-cooper-f57-lci2-1-5t-i3-b38m-fwd" },
        { "title": "Cooper S 2.0T I4 B46O FWD", "url": "/collections/mini-convertible-cooper-s-f57-lci2-2-0t-i4-b46o-fwd" },
        { "title": "JCW 2.0T I4 B48T FWD", "url": "/collections/mini-convertible-jcw-f57-lci2-2-0t-i4-b48t-fwd" }
      ],
      "F57 LCI (2018-2021)": [
        { "title": "Cooper 1.5T I3 B38M FWD", "url": "/collections/mini-convertible-cooper-f57-lci-1-5t-i3-b38m-fwd" },
        { "title": "Cooper S 2.0T I4 B46M FWD", "url": "/collections/mini-convertible-cooper-s-f57-lci-2-0t-i4-b46m-fwd" },
        { "title": "JCW 2.0T I4 B48T FWD", "url": "/collections/mini-convertible-jcw-f57-lci-2-0t-i4-b48t-fwd" }
      ],
      "F57 (2016-2017)": [
        { "title": "Cooper 1.5T I3 B38M FWD", "url": "/collections/mini-convertible-cooper-f57-1-5t-i3-b38m-fwd" },
        { "title": "Cooper S 2.0T I4 B46M FWD", "url": "/collections/mini-convertible-cooper-s-f57-2-0t-i4-b46m-fwd" },
        { "title": "JCW 2.0T I4 B48T FWD", "url": "/collections/mini-convertible-jcw-f57-2-0t-i4-b48t-fwd" }
      ],
      "R57 LCI (2011-2015)": [
        { "title": "Cooper 1.6L I4 N16 FWD", "url": "/collections/mini-convertible-cooper-r57-lci-1-6l-i4-n16-fwd" },
        { "title": "Cooper S 1.6T I4 N18 FWD", "url": "/collections/mini-convertible-cooper-s-r57-lci-1-6t-i4-n18-fwd" },
        { "title": "JCW 1.6T I4 N14 FWD", "url": "/collections/mini-convertible-jcw-r57-lci-1-6t-i4-n14-fwd" },
        { "title": "JCW 1.6T I4 N18 FWD", "url": "/collections/mini-convertible-jcw-r57-lci-1-6t-i4-n18-fwd" }
      ],
      "R57 (2008-2009)": [
        { "title": "Cooper 1.6L I4 N12 FWD", "url": "/collections/mini-convertible-cooper-r57-1-6l-i4-n12-fwd" },
        { "title": "Cooper S 1.6T I4 N14 FWD", "url": "/collections/mini-convertible-cooper-s-r57-1-6t-i4-n14-fwd" },
        { "title": "JCW 1.6T I4 N14 FWD", "url": "/collections/mini-convertible-jcw-r57-1-6t-i4-n14-fwd" }
      ]
    },
    "Countryman": {
      "U25 (2025+)": [
        { "title": "S 2.0T I4 B48O ALL4", "url": "/collections/mini-countryman-s-u25-2-0t-i4-b48o-all4" },
        { "title": "JCW 2.0T I4 B48T ALL4", "url": "/collections/mini-countryman-jcw-u25-2-0t-i4-b48t-all4" }
      ],
      "F60 LCI (2020-2024)": [
        { "title": "Cooper 1.5T I3 B38M FWD", "url": "/collections/mini-countryman-cooper-f60-lci-1-5t-i3-b38m-fwd" },
        { "title": "Cooper 1.5T I3 B38M ALL4", "url": "/collections/mini-countryman-cooper-f60-lci-1-5t-i3-b38m-all4" },
        { "title": "Cooper S 2.0T I4 B46O FWD", "url": "/collections/mini-countryman-cooper-s-f60-lci-2-0t-i4-b46o-fwd" },
        { "title": "Cooper S 2.0T I4 B46O ALL4", "url": "/collections/mini-countryman-cooper-s-f60-lci-2-0t-i4-b46o-all4" },
        { "title": "Cooper SE 1.5T I3 B38M ALL4 PHEV", "url": "/collections/mini-countryman-cooper-se-f60-lci-1-5t-i3-b38m-all4-phev" },
        { "title": "JCW 2.0T I4 B48T ALL4", "url": "/collections/mini-countryman-jcw-f60-lci-2-0t-i4-b48t-all4" }
      ],
      "F60 (2017-2019)": [
        { "title": "Cooper 1.5T I3 B38M FWD", "url": "/collections/mini-countryman-cooper-f60-1-5t-i3-b38m-fwd" },
        { "title": "Cooper 1.5T I3 B38M ALL4", "url": "/collections/mini-countryman-cooper-f60-1-5t-i3-b38m-all4" },
        { "title": "Cooper S 2.0T I4 B46M FWD", "url": "/collections/mini-countryman-cooper-s-f60-2-0t-i4-b46m-fwd" },
        { "title": "Cooper S 2.0T I4 B46M ALL4", "url": "/collections/mini-countryman-cooper-s-f60-2-0t-i4-b46m-all4" },
        { "title": "JCW 2.0T I4 B48T ALL4", "url": "/collections/mini-countryman-jcw-f60-2-0t-i4-b48t-all4" }
      ],
      "R60 LCI (2014-2016)": [
        { "title": "Cooper 1.6L I4 N16 FWD", "url": "/collections/mini-countryman-r60-lci-cooper-1-6l-i4-n16-fwd" },
        { "title": "Cooper S 1.6T I4 N18 FWD", "url": "/collections/mini-countryman-r60-lci-cooper-s-1-6t-i4-n18-fwd" },
        { "title": "Cooper S 1.6T I4 N18 ALL4", "url": "/collections/mini-countryman-r60-lci-cooper-s-1-6t-i4-n18-all4" },
        { "title": "JCW 1.6T I4 N18 ALL4", "url": "/collections/mini-countryman-r60-lci-jcw-1-6t-i4-n18-all4" }
      ],
      "R60 (2011-2013)": [
        { "title": "Cooper 1.6L I4 N16 FWD", "url": "/collections/mini-countryman-r60-cooper-1-6l-i4-n16-fwd" },
        { "title": "Cooper S 1.6T I4 N18 FWD", "url": "/collections/mini-countryman-r60-cooper-s-1-6t-i4-n18-fwd" },
        { "title": "Cooper S 1.6T I4 N18 ALL4", "url": "/collections/mini-countryman-r60-cooper-s-1-6t-i4-n18-all4" },
        { "title": "JCW 1.6T I4 N18 ALL4", "url": "/collections/mini-countryman-r60-jcw-1-6t-i4-n18-all4" }
      ]
    },
    "Coupe": {
      "R58 (2011-2015)": [
        { "title": "Cooper 1.6L I4 N12 FWD", "url": "/collections/mini-coupe-cooper-r58-1-6l-i4-n12-fwd" },
        { "title": "Cooper S 1.6T I4 N18 FWD", "url": "/collections/mini-coupe-cooper-s-r58-1-6t-i4-n18-fwd" },
        { "title": "JCW 1.6T I4 N14 FWD", "url": "/collections/mini-coupe-jcw-r58-1-6t-i4-n14-fwd" },
        { "title": "JCW 1.6T I4 N18 FWD", "url": "/collections/mini-coupe-jcw-r58-1-6t-i4-n18-fwd" }
      ]
    },
    "Hardtop": {
      "F65 • F66 (2025+)": [
        { "title": "Cooper C 1.5T I3 B38M FWD", "url": "/collections/mini-hardtop-cooper-c-f65-f66-1-5t-i3-b38m-fwd" },
        { "title": "Cooper S 2.0T I4 B48O FWD", "url": "/collections/mini-hardtop-cooper-s-f65-f66-2-0t-i4-b48o-fwd" },
        { "title": "JCW 2.0T I4 B48T FWD", "url": "/collections/mini-hardtop-jcw-f65-f66-2-0t-i4-b48t-fwd" }
      ],
      "F55 • F56 LCI2 (2022-2024)": [
        { "title": "Cooper 1.5T I3 B38M FWD", "url": "/collections/mini-hardtop-cooper-f55-f56-lci2-1-5t-i3-b38m-fwd" },
        { "title": "Cooper S 2.0T I4 B46O FWD", "url": "/collections/mini-hardtop-cooper-s-f55-f56-lci2-2-0t-i4-b46o-fwd" },
        { "title": "JCW 2.0T I4 B48T FWD", "url": "/collections/mini-hardtop-jcw-f55-f56-lci2-2-0t-i4-b48t-fwd" }
      ],
      "F55 • F56 LCI (2018-2021)": [
        { "title": "Cooper 1.5T I3 B38M FWD", "url": "/collections/mini-hardtop-cooper-f55-f56-lci-1-5t-i3-b38m-fwd" },
        { "title": "Cooper S 2.0T I4 B46M FWD", "url": "/collections/mini-hardtop-cooper-s-f55-f56-lci-2-0t-i4-b46m-fwd" },
        { "title": "JCW 2.0T I4 B48T FWD", "url": "/collections/mini-hardtop-jcw-f55-f56-lci-2-0t-i4-b48m-fwd" },
        { "title": "JCW GP 2.0T I4 B48T FWD", "url": "/collections/mini-hardtop-jcw-gp-f56-lci-2-0t-i4-b48t-fwd" }
      ],
      "F55 • F56 (2014-2017)": [
        { "title": "Cooper 1.5T I3 B38M FWD", "url": "/collections/mini-hardtop-cooper-f55-f56-1-5t-i3-b38m-fwd" },
        { "title": "Cooper S 2.0T I4 B46M FWD", "url": "/collections/mini-hardtop-cooper-s-f55-f56-2-0t-i4-b46m-fwd" },
        { "title": "JCW 2.0T I4 B48T FWD", "url": "/collections/mini-hardtop-jcw-f55-f56-2-0t-i4-b48m-fwd" }
      ],
      "R56 LCI (2011-2013)": [
        { "title": "Cooper 1.6L I4 N16 FWD", "url": "/collections/mini-hardtop-cooper-r56-lci-1-6l-i4-n16-fwd" },
        { "title": "Cooper S 1.6T I4 N18 FWD", "url": "/collections/mini-hardtop-cooper-s-r56-lci-1-6t-i4-n18-fwd" },
        { "title": "JCW 1.6T I4 N14 FWD", "url": "/collections/mini-hardtop-jcw-r56-lci-1-6t-i4-n14-fwd" },
        { "title": "JCW 1.6T I4 N18 FWD", "url": "/collections/mini-hardtop-jcw-r56-lci-1-6t-i4-n18-fwd" },
        { "title": "JCW GP 1.6T I4 N18 FWD", "url": "/collections/mini-hardtop-jcw-gp-r56-lci-1-6t-i4-n18-fwd" }
      ],
      "R56 (2007-2010)": [
        { "title": "Cooper 1.6L I4 N12 FWD", "url": "/collections/mini-hardtop-cooper-r56-1-6l-i4-n12-fwd" },
        { "title": "Cooper S 1.6T I4 N14 FWD", "url": "/collections/mini-hardtop-cooper-s-r56-1-6t-i4-n14-fwd" },
        { "title": "JCW 1.6T I4 N14 FWD", "url": "/collections/mini-hardtop-jcw-r56-1-6t-i4-n14-fwd" }
      ]
    },
    "Paceman": {
      "R61 (2013-2016)": [
        { "title": "Cooper 1.6L I4 N16 FWD", "url": "/collections/mini-paceman-cooper-r61-1-6l-i4-n16-fwd" },
        { "title": "Cooper S 1.6T I4 N18 FWD", "url": "/collections/mini-paceman-cooper-s-r61-1-6t-i4-n18-fwd" },
        { "title": "Cooper S 1.6T I4 N18 ALL4", "url": "/collections/mini-paceman-cooper-s-r61-1-6t-i4-n18-all4" },
        { "title": "JCW 1.6T I4 N18 ALL4", "url": "/collections/mini-paceman-jcw-r61-1-6t-i4-n18-all4" }
      ]
    },
    "Roadster": {
      "R59 (2012-2015)": [
        { "title": "Cooper 1.6L I4 N16 FWD", "url": "/collections/mini-roadster-cooper-r59-1-6l-i4-n16-fwd" },
        { "title": "Cooper S 1.6T I4 N18 FWD", "url": "/collections/mini-roadster-cooper-s-r59-1-6t-i4-n18-fwd" },
        { "title": "JCW 1.6T I4 N18 FWD", "url": "/collections/mini-roadster-jcw-r59-1-6t-i4-n18-fwd" }
      ]
    }
  },
  "Porsche": {
    "Macan": {
      "95B.3 (2022-2023)": [
        { "title": "2.0T I4 EA888.4 AWD", "url": "/collections/porsche-macan-95b-3-2-0t-i4-ea888-4-awd" },
        { "title": "T 2.0T I4 EA888.4 AWD", "url": "/collections/porsche-macan-t-95b-3-2-0t-i4-ea888-4-awd" },
        { "title": "S 2.9T V6 EA839 AWD", "url": "/collections/porsche-macan-s-95b-3-2-9t-v6-ea839-awd" },
        { "title": "GTS 2.9T V6 EA839 AWD", "url": "/collections/porsche-macan-gts-95b-3-2-9t-v6-ea839-awd" }
      ],
      "95B.2 (2019-2021)": [
        { "title": "2.0T I4 EA888.3 AWD", "url": "/collections/porsche-macan-95b-2-2-0t-i4-ea888-3-awd" },
        { "title": "S 3.0T V6 EA839 AWD", "url": "/collections/porsche-macan-s-95b-2-3-0t-v6-ea839-awd" },
        { "title": "GTS 2.9T V6 EA839 AWD", "url": "/collections/porsche-macan-gts-95b-2-2-9t-v6-ea839-awd" },
        { "title": "Turbo 2.9T V6 EA839 AWD", "url": "/collections/porsche-macan-turbo-95b-2-2-9t-v6-ea839-awd" }
      ],
      "95B (2015-2018)": [
        { "title": "2.0T I4 EA888.3 AWD", "url": "/collections/porsche-macan-95b-2-0t-i4-ea888-3-awd" },
        { "title": "S 3.0TT V6 MCT.MA AWD", "url": "/collections/porsche-macan-s-95b-3-0tt-v6-mct-ma-awd" },
        { "title": "S Diesel 3.0T V6 EA897 AWD", "url": "/collections/porsche-macan-s-95b-diesel-3-0t-v6-ea897-awd" },
        { "title": "GTS 3.0TT V6 MCT.MA AWD", "url": "/collections/porsche-macan-gts-95b-3-0tt-v6-mct-la-awd" },
        { "title": "Turbo 3.6TT V6 MCT.LA AWD", "url": "/collections/porsche-macan-turbo-95b-3-6tt-v6-mct-la-awd" }
      ]
    }
  },
  "Volkswagen": {
    "Arteon": {
      "3G8.2 (2022-2023)": [
        { "title": "2.0T I4 EA888.4 FWD", "url": "/collections/volkswagen-arteon-3g8-2-2-0t-i4-ea888-4-fwd" },
        { "title": "2.0T I4 EA888.4 4Motion", "url": "/collections/volkswagen-arteon-3g8-2-2-0t-i4-ea888-4-4motion" }
      ],
      "3G8 (2019-2021)": [
        { "title": "2.0T I4 EA888.3 FWD", "url": "/collections/volkswagen-arteon-3g8-2-0t-i4-ea888-3-fwd" },
        { "title": "2.0T I4 EA888.3 4Motion", "url": "/collections/volkswagen-arteon-3g8-2-0t-i4-ea888-3-4motion" }
      ]
    },
    "Atlas • Cross Sport": {
      "CA1.3 (2024-2026)": [
        { "title": "2.0T I4 EA88.4 FWD", "url": "/collections/volkswagen-atlas-ca3-2-0t-i4-ea888-4-fwd" },
        { "title": "2.0T I4 EA88.4 4Motion", "url": "/collections/volkswagen-atlas-ca3-2-0t-i4-ea888-4-4motion" }
      ],
      "CA1.2 (2021-2023)": [
        { "title": "2.0T I4 EA888.3 FWD", "url": "/collections/volkswagen-atlas-ca2-2-0t-ea888-3-fwd" },
        { "title": "2.0T I4 EA888.3 4Motion", "url": "/collections/volkswagen-atlas-ca2-2-0t-ea888-3-4motion" },
        { "title": "3.6L VR6 EA390 FWD", "url": "/collections/volkswagen-atlas-ca2-3-6l-vr6-ea390-fwd" },
        { "title": "3.6L VR6 EA390 4Motion", "url": "/collections/volkswagen-atlas-ca2-3-6l-vr6-ea390-4motion" }
      ],
      "CA1 (2018-2020)": [
        { "title": "2.0T I4 EA888.3 FWD", "url": "/collections/volkswagen-atlas-ca1-2-0t-ea888-3-fwd" },
        { "title": "2.0T I4 EA888.3 4Motion", "url": "/collections/volkswagen-atlas-ca1-2-0t-ea888-3-4motion" },
        { "title": "3.6L VR6 EA390 FWD", "url": "/collections/volkswagen-atlas-ca1-3-6l-vr6-ea390-fwd" },
        { "title": "3.6L VR6 EA390 4Motion", "url": "/collections/volkswagen-atlas-ca1-3-6l-vr6-ea390-4motion" }
      ]
    },
    "Beetle": {
      "Mk6 (2012-2019)": [
        { "title": "2.0T I4 EA888.3B FWD", "url": "/collections/volkswagen-beetle-mk6-2-0t-i4-ea888-3b-fwd" },
        { "title": "2.0T I4 EA888.3 FWD", "url": "/collections/volkswagen-beetle-mk6-2-0t-i4-ea888-3-fwd" },
        { "title": "1.8T I4 EA888.3 FWD", "url": "/collections/volkswagen-beetle-mk6-1-8t-i4-ea888-3-fwd" },
        { "title": "Turbo 2.0T I4 EA888.2 FWD", "url": "/collections/volkswagen-beetle-turbo-mk6-2-0t-i4-ea888-2-fwd" },
        { "title": "2.0T TDI I4 EA189 FWD", "url": "/collections/volkswagen-beetle-mk6-2-0t-tdi-i4-ea189-fwd" },
        { "title": "2.0T TDI I4 EA288 FWD", "url": "/collections/volkswagen-beetle-mk6-2-0t-tdi-i4-ea288-fwd" },
        { "title": "2.5L I5 EA855 FWD", "url": "/collections/volkswagen-beetle-mk6-2-5l-i5-ea855-fwd" }
      ],
      "Mk4 (1998-2010)": [
        { "title": "1.8T I4 EA113 FWD", "url": "/collections/volkswagen-beetle-mk4-1-8t-i4-ea113-fwd" },
        { "title": "1.9T TDI I4 EA189 FWD", "url": "/collections/volkswagen-beetle-mk4-1-9t-tdi-i4-ea189-fwd" },
        { "title": "2.0L I4 EA827 FWD", "url": "/collections/volkswagen-beetle-mk4-2-0l-i4-ea827-fwd" },
        { "title": "2.5L I5 EA855 FWD", "url": "/collections/volkswagen-beetle-mk4-2-5l-i5-ea855-fwd" }
      ]
    },
    "Cabriolet": {
      "Mk3 (1995-2002)": [
        { "title": "2.0L I4 EA827 FWD", "url": "/collections/volkswagen-cabriolet-mk3-2-0l-i4-ea827-fwd" }
      ],
      "Mk1 (1979-1993)": [
        { "title": "1.8L I4 EA827 FWD", "url": "/collections/volkswagen-cabriolet-mk1-1-8l-i4-ea827-fwd" }
      ]
    },
    "CC": {
      "B6.2 (2013-2017)": [
        { "title": "2.0T I4 EA888.3 FWD", "url": "/collections/volkswagen-cc-b6-2-2-0t-i4-ea888-3-fwd" }
      ],
      "B6 (2008-2017)": [
        { "title": "2.0T I4 EA888.2 FWD", "url": "/collections/volkswagen-cc-b6-2-2-0t-i4-ea888-2-fwd" },
        { "title": "3.6L VR6 EA390 FWD", "url": "/collections/volkswagen-cc-b6-3-6l-vr6-ea390-fwd" },
        { "title": "3.6L VR6 EA390 4Motion", "url": "/collections/volkswagen-cc-b6-3-6l-vr6-ea390-4motion" }
      ]
    },
    "Corrado": {
      "All (1990-1995)": [
        { "title": "1.8L I4 EA827 FWD", "url": "/collections/volkswagen-corrado-1-8l-i4-ea827-fwd" },
        { "title": "2.8L VR6 EA390 12V FWD", "url": "/collections/volkswagen-corrado-2-8l-vr6-ea390-12v-fwd" }
      ]
    },
    "EOS": {
      "Mk6 (2012-2016)": [
        { "title": "2.0T I4 EA888.1 FWD", "url": "/collections/volkswagen-eos-mk6-2-0t-i4-ea888-1-fwd" }
      ],
      "Mk5 (2007-2011)": [
        { "title": "2.0T I4 EA888.1 FWD", "url": "/collections/volkswagen-eos-mk5-2-0t-i4-ea888-1-fwd" },
        { "title": "2.0T I4 EA113 FWD", "url": "/collections/volkswagen-eos-mk5-2-0t-i4-ea113-fwd" },
        { "title": "3.2L VR6 EA390 FWD", "url": "/collections/volkswagen-eos-mk5-3-6l-vr6-ea390-fwd" }
      ]
    },
    "Golf • GTI • R": {
      "Mk8.2 (2025+)": [
        { "title": "GTI 2.0T I4 EA888.4 FWD", "url": "/collections/volkswagen-golf-gti-mk8-2-2-0t-i4-ea888-4-fwd" },
        { "title": "R 2.0T I4 EA888.4 4Motion", "url": "/collections/volkswagen-golf-r-mk8-2-2-0t-i4-ea888-4-4motion" }
      ],
      "Mk8 (2022-2024)": [
        { "title": "GTI 2.0T I4 EA888.4 FWD", "url": "/collections/volkswagen-golf-gti-mk8-2-0t-i4-ea888-4-fwd" },
        { "title": "R 2.0T I4 EA888.4 4Motion", "url": "/collections/volkswagen-golf-r-mk8-2-0t-i4-ea888-4-4motion" }
      ],
      "Mk7.2 (2018-2021)": [
        { "title": "1.4T I4 EA211 FWD", "url": "/collections/volkswagen-golf-mk7-2-1-4t-i4-ea211-fwd" },
        { "title": "1.8T I4 EA888.3 FWD", "url": "/collections/volkswagen-golf-mk7-2-1-8t-i4-ea888-3-fwd" },
        { "title": "GTI 2.0T I4 EA888.3 FWD", "url": "/collections/volkswagen-golf-gti-mk7-2-2-0t-i4-ea888-3-fwd" },
        { "title": "R 2.0T I4 EA888.3 4Motion", "url": "/collections/volkswagen-golf-r-mk7-2-2-0t-i4-ea888-3-4motion" },
        { "title": "Alltrack 1.8T I4 EA888.3 4Motion", "url": "/collections/volkswagen-golf-alltrack-mk7-2-1-8t-i4-ea888-3-4motion" },
        { "title": "Sportwagen 1.4T I4 EA211 FWD", "url": "/collections/volkswagen-golf-sportwagen-mk7-2-1-4t-i4-ea211-fwd" },
        { "title": "Sportwagen 1.8T I4 EA888.3 FWD", "url": "/collections/volkswagen-golf-sportwagen-mk7-2-1-8t-i4-ea888-3-fwd" },
        { "title": "Sportwagen 1.8T I4 EA888.3 4Motion", "url": "/collections/volkswagen-golf-sportwagen-mk7-2-1-8t-i4-ea888-3-4motion" },
        { "title": "e-Golf 100kW EV FWD", "url": "/collections/volkswagen-e-golf-mk7-2-100kw-fwd" }
      ],
      "Mk7 (2015-2017)": [
        { "title": "e-Golf 85kW EV FWD", "url": "/collections/volkswagen-e-golf-mk7-2-85kw-fwd" },
        { "title": "1.8T I4 EA888.3 FWD", "url": "/collections/volkswagen-golf-mk7-1-8t-i4-ea888-3-fwd" },
        { "title": "2.0T TDI I4 EA288 FWD", "url": "/collections/volkswagen-golf-mk7-2-0t-tdi-i4-ea288-fwd" },
        { "title": "GTI 2.0T I4 EA888.3 FWD", "url": "/collections/volkswagen-golf-gti-mk7-2-0t-i4-ea888-3-fwd" },
        { "title": "R 2.0T I4 EA888.3 4Motion", "url": "/collections/volkswagen-golf-r-mk7-2-0t-i4-ea888-3-4motion" },
        { "title": "Alltrack 1.8T I4 EA888.3 4Motion", "url": "/collections/volkswagen-golf-alltrack-mk7-1-8t-i4-ea888-3-4motion" },
        { "title": "Sportwagen 1.8T I4 EA888.3 FWD", "url": "/collections/volkswagen-golf-sportwagen-mk7-1-8t-i4-ea888-3-fwd" },
        { "title": "Sportwagen 1.8T I4 EA888.3 4Motion", "url": "/collections/volkswagen-golf-sportwagen-mk7-1-8t-i4-ea888-3-4motion" },
        { "title": "Sportwagen 2.0T TDI EA288 FWD", "url": "/collections/volkswagen-golf-sportwagen-mk7-2-0t-tdi-ea288-fwd" }
      ],
      "Mk6 (2010-2014)": [
        { "title": "2.0T TDI I4 EA189 FWD", "url": "/collections/volkswagen-golf-mk6-2-0t-tdi-i4-ea189-fwd" },
        { "title": "2.5L I5 EA855 FWD", "url": "/collections/volkswagen-golf-mk6-2-5l-i5-ea855-fwd" },
        { "title": "GTI 2.0T I4 EA888.1 FWD", "url": "/collections/volkswagen-golf-gti-mk6-2-0t-i4-ea888-1-fwd" },
        { "title": "R 2.0T I4 EA113 4Motion", "url": "/collections/volkswagen-golf-r-mk6-2-0t-i4-ea113-4motion" }
      ],
      "Mk5 (2006-2009)": [
        { "title": "Rabbit 2.5L I5 EA855 FWD", "url": "/collections/volkswagen-rabbit-mk5-2-5l-i5-ea855-fwd" },
        { "title": "GTI 2.0T I4 EA113 FWD", "url": "/collections/volkswagen-golf-gti-mk5-2-0t-i4-ea113-fwd" },
        { "title": "GTI 2.0T I4 EA888.1 FWD", "url": "/collections/volkswagen-golf-gti-mk5-2-0t-i4-ea888-1-fwd" },
        { "title": "R32 3.2L VR6 EA390 4Motion", "url": "/collections/volkswagen-golf-r32-mk5-3-2l-vr6-ea390-4motion" }
      ],
      "Mk4 (1999-2005)": [
        { "title": "1.9T TDI I4 EA189 FWD", "url": "/collections/volkswagen-golf-mk4-1-9t-tdi-i4-ea189-fwd" },
        { "title": "2.0L I4 EA827 FWD", "url": "/collections/volkswagen-golf-mk4-2-0l-i4-ea827-fwd" },
        { "title": "GTI 1.8T I4 EA113 FWD", "url": "/collections/volkswagen-golf-gti-mk4-1-8t-i4-ea113-fwd" },
        { "title": "GTI 2.8L VR6 EA390 12V FWD", "url": "/collections/volkswagen-golf-gti-mk4-2-8l-vr6-ea390-12v-fwd" },
        { "title": "GTI 2.8L VR6 EA390 24V FWD", "url": "/collections/volkswagen-golf-gti-mk4-2-8l-vr6-ea390-24v-fwd" },
        { "title": "R32 3.2L VR6 EA390 4Motion", "url": "/collections/volkswagen-golf-r32-mk4-3-2l-vr6-ea390-4motion" }
      ],
      "Mk3 (1994-1998)": [
        { "title": "2.0L I4 EA827 FWD", "url": "/collections/volkswagen-golf-mk3-2-0l-i4-ea827-fwd" },
        { "title": "GTI 2.0L I4 EA827 FWD", "url": "/collections/volkswagen-golf-gti-mk3-2-0l-i4-ea827-fwd" },
        { "title": "GTI 2.8L VR6 EA390 12V FWD", "url": "/collections/volkswagen-golf-gti-mk3-2-8l-vr6-ea390-12v-fwd" }
      ],
      "Mk2 (1985-1993)": [
        { "title": "1.8L I4 EA827 FWD", "url": "/collections/volkswagen-golf-mk2-1-8l-i4-ea827-fwd" },
        { "title": "GTI 1.8L I4 EA827 8V FWD", "url": "/collections/volkswagen-golf-gti-mk2-1-8l-i4-ea827-8v-fwd" },
        { "title": "GTI 1.8L I4 EA827 16V FWD", "url": "/collections/volkswagen-golf-gti-mk2-1-8l-i4-ea827-16v-fwd" },
        { "title": "GTI 2.0L I4 EA827 16V FWD", "url": "/collections/volkswagen-golf-gti-mk2-2-0l-i4-ea827-16v-fwd" }
      ],
      "Mk1 (1975-1984)": [
        { "title": "1.5L I4 EA827 FWD", "url": "/collections/volkswagen-rabbit-gti-mk1-1-5l-i4-ea827-fwd" },
        { "title": "1.6L I4 EA827 FWD", "url": "/collections/volkswagen-rabbit-gti-mk1-1-6l-i4-ea827-fwd" },
        { "title": "1.7L I4 EA827 FWD", "url": "/collections/volkswagen-rabbit-gti-mk1-1-7l-i4-ea827-fwd" },
        { "title": "GTI 1.8L I4 EA827 FWD", "url": "/collections/volkswagen-rabbit-mk1-1-8l-i4-ea827-fwd" }
      ]
    },
    "ID.4": {
      "MEB (2021+)": [
        { "title": "62 kWh EV RWD", "url": "/collections/volkswagen-id-4-meb-62-kwh-ev-rwd" },
        { "title": "82 kWh EV RWD", "url": "/collections/volkswagen-id-4-meb-82-kwh-ev-rwd" },
        { "title": "82 kWh EV AWD", "url": "/collections/volkswagen-id-4-meb-82-kwh-ev-awd" }
      ]
    },
    "Jetta": {
      "Mk7.3 (2025+)": [
        { "title": "1.5T I4 EA211.1 FWD", "url": "/collections/volkswagen-jetta-mk7-3-1-5t-i4-ea211-1-fwd" },
        { "title": "GLI 2.0T I4 EA888.3 FWD", "url": "/collections/volkswagen-jetta-gli-mk7-3-2-0t-i4-ea888-3-fwd" }
      ],
      "Mk7.2 (2022-2024)": [
        { "title": "1.5T I4 EA211.1 FWD", "url": "/collections/volkswagen-jetta-mk7-2-1-5t-i4-ea211-1-fwd" },
        { "title": "GLI 2.0T I4 EA888.3 FWD", "url": "/collections/volkswagen-jetta-gli-mk7-2-2-0t-i4-ea888-3-fwd" }
      ],
      "Mk7 (2019-2021)": [
        { "title": "1.4T I4 EA211 FWD", "url": "/collections/volkswagen-jetta-mk7-1-4t-i4-ea211-1-fwd" },
        { "title": "GLI 2.0T I4 EA888.3 FWD", "url": "/collections/volkswagen-jetta-gli-mk7-2-0t-i4-ea888-3-fwd" }
      ],
      "Mk6 (2010-2018)": [
        { "title": "1.4T I4 EA211 FWD", "url": "/collections/volkswagen-jetta-mk6-1-4t-i4-ea211-fwd" },
        { "title": "1.8T I4 EA888.3 FWD", "url": "/collections/volkswagen-jetta-mk6-1-8t-i4-ea888-3-fwd" },
        { "title": "2.0L I4 EA113 FWD", "url": "/collections/volkswagen-jetta-mk6-2-0l-i4-ea113-fwd" },
        { "title": "2.0T TDI I4 EA189 FWD", "url": "/collections/volkswagen-jetta-mk6-2-0t-tdi-i4-ea189-fwd" },
        { "title": "2.0T TDI I4 EA288 FWD", "url": "/collections/volkswagen-jetta-mk6-2-0t-tdi-i4-ea288-fwd" },
        { "title": "2.5L I5 EA855 FWD", "url": "/collections/volkswagen-jetta-mk6-2-5l-i5-ea855-fwd" },
        { "title": "GLI 2.0T I4 EA888.1 FWD", "url": "/collections/volkswagen-jetta-gli-mk6-2-0t-i4-ea888-1-fwd" },
        { "title": "GLI 2.0T I4 EA888.3 FWD", "url": "/collections/volkswagen-jetta-gli-mk6-2-0t-i4-ea888-3-fwd" },
        { "title": "Sportwagen 2.5L I5 EA855 FWD", "url": "/collections/volkswagen-jetta-sportwagen-mk6-2-5l-i5-ea855-fwd" },
        { "title": "Sportwagen 2.0T TDI I4 EA189 FWD", "url": "/collections/volkswagen-jetta-sportwagen-mk6-2-0t-tdi-i4-ea189-fwd" },
        { "title": "1.9T TDI I4 EA188 FWD", "url": "/collections/volkswagen-jetta-mk5-1-9t-tdi-i4-ea188-fwd" }
      ],
      "Mk5 (2005-2010)": [
        { "title": "2.0T TDI I4 EA189 FWD", "url": "/collections/volkswagen-jetta-mk5-2-0t-tdi-i4-ea189-fwd" },
        { "title": "2.5L I5 EA855 FWD", "url": "/collections/volkswagen-jetta-mk5-2-5l-i5-ea855-fwd" },
        { "title": "GLI 2.0T I4 EA113 FWD", "url": "/collections/volkswagen-jetta-gli-mk5-2-0t-i4-ea113-fwd" },
        { "title": "GLI 2.0T I4 EA888.1 FWD", "url": "/collections/volkswagen-jetta-gli-mk5-2-0t-i4-ea888-1-fwd" },
        { "title": "Sportwagen 2.5L I5 EA855 FWD", "url": "/collections/volkswagen-jetta-sportwagen-mk5-2-5l-i5-ea855-fwd" },
        { "title": "Sportwagen 2.0T TDI I4 EA189 FWD", "url": "/collections/volkswagen-jetta-sportwagen-mk5-2-0t-tdi-i4-ea189-fwd" }
      ],
      "Mk4 (1999-2005)": [
        { "title": "1.8T I4 EA113 150HP FWD", "url": "/collections/volkswagen-jetta-mk4-1-8t-i4-ea113-150hp-fwd" },
        { "title": "1.8T I4 EA113 180HP FWD", "url": "/collections/volkswagen-jetta-mk4-1-8t-i4-ea113-180hp-fwd" },
        { "title": "1.9T TDI I4 EA188 FWD", "url": "/collections/volkswagen-jetta-mk4-1-9t-tdi-i4-ea188-fwd" },
        { "title": "1.9T TDI I4 EA189 FWD", "url": "/collections/volkswagen-jetta-mk4-1-9t-tdi-i4-ea189-fwd" },
        { "title": "2.0L I4 EA827 FWD", "url": "/collections/volkswagen-jetta-mk4-2-0l-i4-ea827-fwd" },
        { "title": "2.8L VR6 EA390 12V FWD", "url": "/collections/volkswagen-jetta-mk4-2-8l-vr6-ea390-12v-fwd" },
        { "title": "2.8L VR6 EA390 24V FWD", "url": "/collections/volkswagen-jetta-mk4-2-8l-vr6-ea390-24v-fwd" },
        { "title": "GLI 1.8T I4 EA113 FWD", "url": "/collections/volkswagen-jetta-mk4-gli-1-8t-i4-ea113-180hp-fwd" },
        { "title": "GLI 2.8L VR6 EA390 24V FWD", "url": "/collections/volkswagen-jetta-gli-mk4-2-8l-vr6-ea390-24v-fwd" }
      ],
      "Mk3 (1994-1999)": [
        { "title": "1.9T TDI I4 EA189 FWD", "url": "/collections/volkswagen-jetta-mk3-1-9t-tdi-i4-ea189-fwd" },
        { "title": "1.9T TDI I4 EA827 FWD", "url": "/collections/volkswagen-jetta-mk3-1-9t-td-i4-ea827-fwd" },
        { "title": "2.0L I4 EA827 FWD", "url": "/collections/volkswagen-jetta-mk3-2-0l-i4-ea827-fwd" },
        { "title": "2.8L VR6 EA390 FWD", "url": "/collections/volkswagen-jetta-mk3-2-8l-vr6-ea390-fwd" }
      ],
      "Mk2 (1985-1993)": [
        { "title": "1.8L I4 EA827 FWD", "url": "/collections/volkswagen-jetta-mk2-1-8l-i4-ea827-fwd" },
        { "title": "GLI 1.8L I4 EA827 FWD", "url": "/collections/volkswagen-jetta-gli-mk2-1-8l-i4-ea827-fwd" },
        { "title": "GLI 2.0L I4 EA827 FWD", "url": "/collections/volkswagen-jetta-gli-mk2-2-0l-i4-ea827-fwd" }
      ],
      "Mk1 (1980-1984)": [
        { "title": "1.6L I4 EA827 FWD", "url": "/collections/volkswagen-jetta-mk1-1-6l-i4-ea827-fwd" },
        { "title": "1.7L I4 EA827 FWD", "url": "/collections/volkswagen-jetta-mk1-1-7l-i4-ea827-fwd" },
        { "title": "GLI 1.8L I4 EA827 FWD", "url": "/collections/volkswagen-jetta-gli-mk1-1-8l-i4-ea827-fwd" }
      ]
    },
    "Passat": {
      "B7.2 (2020-2022)": [
        { "title": "2.0T I4 EA888.3B FWD", "url": "/collections/volkswagen-passat-b7-2-2-0t-i4-ea888-3b-fwd" }
      ],
      "B7 (2012-2019)": [
        { "title": "1.8T I4 EA888.3 FWD", "url": "/collections/volkswagen-passat-b7-1-8t-i4-ea888-3-fwd" },
        { "title": "2.0T TDI I4 EA288 FWD", "url": "/collections/volkswagen-passat-b7-2-0t-tdi-i4-ea288-fwd" },
        { "title": "2.0T TDI I4 EA189 FWD", "url": "/collections/volkswagen-passat-b7-2-0t-tdi-i4-ea189-fwd" },
        { "title": "2.5L I5 EA855 FWD", "url": "/collections/volkswagen-passat-b7-2-5l-i5-ea855-fwd" },
        { "title": "3.6L VR6 EA390 FWD", "url": "/collections/volkswagen-passat-b7-3-6l-vr6-ea390-fwd" }
      ],
      "B6 (2006-2010)": [
        { "title": "2.0T I4 EA888.1 FWD", "url": "/collections/volkswagen-passat-b6-2-0t-i4-ea888-1-fwd" },
        { "title": "2.0T I4 EA113 FWD", "url": "/collections/volkswagen-passat-b6-2-0t-i4-ea113-fwd" },
        { "title": "3.6L VR6 EA390 FWD", "url": "/collections/volkswagen-passat-b6-3-6l-vr6-ea390-fwd" },
        { "title": "3.6L VR6 EA390 4Motion", "url": "/collections/volkswagen-passat-b6-3-6l-vr6-ea390-4motion" }
      ],
      "B5.2 (2001-2005)": [
        { "title": "1.8T I4 EA113 FWD", "url": "/collections/volkswagen-passat-b5-2-1-8t-i4-ea113-fwd" },
        { "title": "2.0T TDI I4 EA188 FWD", "url": "/collections/volkswagen-passat-b5-2-2-0t-tdi-i4-ea188-fwd" },
        { "title": "2.8L V6 EA835 FWD", "url": "/collections/volkswagen-passat-b5-2-2-8l-v6-ea835-fwd" },
        { "title": "4.0L W8 BDN 4Motion", "url": "/collections/volkswagen-passat-b5-2-4-0l-w8-bdn-4motion" }
      ],
      "B5 (1996-2000)": [
        { "title": "1.8T I4 EA113 FWD", "url": "/collections/volkswagen-passat-b5-1-8t-i4-ea113-fwd" },
        { "title": "2.8L V6 EA835 FWD", "url": "/collections/volkswagen-passat-b5-2-8l-v6-ea835-fwd" }
      ],
      "B4 (1995-1997)": [
        { "title": "1.9T TDI I4 EA189 FWD", "url": "/collections/volkswagen-passat-b4-1-9t-tdi-i4-ea189-fwd" },
        { "title": "2.0L I4 EA827 8V FWD", "url": "/collections/volkswagen-passat-b4-2-0l-i4-ea827-8v-fwd" },
        { "title": "2.8L VR6 EA390 FWD", "url": "/collections/volkswagen-passat-b4-2-8l-vr6-ea390-fwd" }
      ],
      "B3 (1988-1994)": [
        { "title": "2.0L I4 EA827 16V FWD", "url": "/collections/volkswagen-passat-b3-2-0l-i4-ea827-16v-fwd" },
        { "title": "2.8L VR6 EA390 FWD", "url": "/collections/volkswagen-passat-b3-2-8l-vr6-ea390-fwd" }
      ]
    },
    "Scirocco": {
      "Mk3 (2008-2017)": [
        { "title": "2.0T I4 EA888.1 FWD", "url": "/collections/volkswagen-scirocco-mk3-2-0t-i4-ea888-1-fwd" },
        { "title": "R 2.0T I4 EA113 FWD", "url": "/collections/volkswagen-scirocco-r-mk3-2-0t-i4-ea113-fwd" }
      ],
      "Mk2 (1982-1988)": [
        { "title": "1.8L I4 EA827 8V FWD", "url": "/collections/volkswagen-scirocco-mk2-1-8l-i4-ea827-8v-fwd" },
        { "title": "1.8L I4 EA827 16V FWD", "url": "/collections/volkswagen-scirocco-mk2-1-8l-i4-ea827-16v-fwd" }
      ],
      "Mk1 (1975-1981)": [
        { "title": "1.7L I4 EA827 FWD", "url": "/collections/volkswagen-scirocco-mk1-1-8l-i4-ea827-fwd" },
        { "title": "1.5L I4 EA827 FWD", "url": "/collections/volkswagen-scirocco-mk1-1-5l-i4-ea827-fwd" }
      ]
    },
    "Taos": {
      "MK1.2 (2025+)": [
        { "title": "1.5T I4 EA211.1 FWD", "url": "/collections/volkswagen-taos-mk1-2-1-5t-i4-ea211-1-fwd" },
        { "title": "1.5T I4 EA211.1 4Motion", "url": "/collections/volkswagen-taos-mk1-2-1-5t-i4-ea211-1-4motion" }
      ],
      "Mk1 (2022-2024)": [
        { "title": "1.5T I4 EA211.1 FWD", "url": "/collections/volkswagen-taos-mk1-1-5t-i4-ea211-1-fwd" },
        { "title": "1.5T I4 EA211.1 4Motion", "url": "/collections/volkswagen-taos-mk1-1-5t-i4-ea211-1-4motion" }
      ]
    },
    "Tiguan": {
      "Mk3 (2025+)": [
        { "title": "2.0T I4 EA888.5 FWD", "url": "/collections/volkswagen-tiguan-mk3-2-0t-i4-ea888-5-fwd" },
        { "title": "2.0T I4 EA888.5 4Motion", "url": "/collections/volkswagen-tiguan-mk3-2-0t-i4-ea888-5-4motion" },
        { "title": "Turbo 2.0T I4 EA888.5 4Motion", "url": "/collections/volkswagen-tiguan-mk3-turbo-2-0t-i4-ea888-5-4motion" }
      ],
      "Mk2.2 (2022-2024)": [
        { "title": "2.0T I4 EA888.3B FWD", "url": "/collections/volkswagen-tiguan-mk2-2-2-0t-i4-ea888-3b-fwd" },
        { "title": "2.0T I4 EA888.3B 4Motion", "url": "/collections/volkswagen-tiguan-mk2-2-2-0t-i4-ea888-3b-4motion" }
      ],
      "Mk2 (2018-2021)": [
        { "title": "2.0T I4 EA888.3B FWD", "url": "/collections/volkswagen-tiguan-mk2-2-0t-i4-ea888-3b-fwd" },
        { "title": "2.0T I4 EA888.3B 4Motion", "url": "/collections/volkswagen-tiguan-mk2-2-0t-i4-ea888-3b-4motion" }
      ],
      "Mk1 (2008-2017)": [
        { "title": "2.0T I4 EA888.1 FWD", "url": "/collections/volkswagen-tiguan-mk1-2-0t-i4-ea888-1-fwd" },
        { "title": "2.0T I4 EA888.1 4Motion", "url": "/collections/volkswagen-tiguan-mk1-2-0t-i4-ea888-1-4motion" }
      ]
    },
    "Touareg": {
      "7P (2011-2017)": [
        { "title": "3.0S V6 EA837 4Motion", "url": "/collections/volkswagen-touareg-7p-3-0s-v6-ea837-4motion" },
        { "title": "3.6L VR6 EA390 4Motion", "url": "/collections/volkswagen-touareg-7p-3-6l-vr6-ea390-4motion" }
      ],
      "7L (2004-2010)": [
        { "title": "3.0T TDI V6 EA897 4Motion", "url": "/collections/volkswagen-touareg-7p-3-0t-tdi-v6-ea897-4motion" },
        { "title": "3.0T TDI V6 EA896 4Motion", "url": "/collections/volkswagen-touareg-7l-3-0t-tdi-v6-ea896-4motion" },
        { "title": "3.2L VR6 EA390 4Motion", "url": "/collections/volkswagen-touareg-7l-3-2l-vr6-ea390-4motion" },
        { "title": "3.6L VR6 EA390 4Motion", "url": "/collections/volkswagen-touareg-7l-3-6l-vr6-ea390-4motion" },
        { "title": "4.2L V8 EA824 4Motion", "url": "/collections/volkswagen-touareg-7l-4-2l-v8-ea824-4motion" },
        { "title": "5.0L TDI V10 BWF 4Motion", "url": "/collections/volkswagen-touareg-7l-5-0l-tdi-v10-bwf-4motion" }
      ]
    }
  }
};

document.dispatchEvent(new CustomEvent('vehicleDb:loaded'));